/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

import options from '../../options.json'
import dayjs from 'dayjs'

const loadOptions = (uid) => (uid in options ? options[uid].values : [])
const thisYear = dayjs().year()

export const pages = {
  'confirm-cancel': {
    modal: true,
    text: [],
    buttons: [
      { label: 'Yes', id: 'yes', uid: '0baa62eba1b1a7d7', control: true },
      { label: 'No', id: 'no', uid: '6c0e0e2956ec3933', control: true },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '9bc15702a2e49228',
      content: ['Are you sure you want to cancel this application?'],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'quotation-details': {
    buttons: [
      {
        control: true,
        id: 'next',
        label: 'Next',
        uid: '26ca340069ec84e5',
      },
      {
        control: true,
        id: 'cancel',
        label: 'Cancel',
        uid: 'e25c3188a733209e',
      },
    ],
    class: 'life-time-needs-quotation-details',
    context: 'Life Time Needs Quotation Details',
    item: {
      content: [
        {
          content: '<h2 id="choose-your-cover">Choose your cover</h2>\n',
          id: 'system-constant',
          label: '',
          readonly: true,
          type: 'html',
          uid: '552d19e7a2f676a3',
        },
        {
          content:
            '<p>To be able to provide you with a quick quotation we will need the following information from you.</p>\n',
          id: 'system-constant',
          label: '',
          readonly: true,
          type: 'html',
          uid: 'a1fcd090d9138ba4',
        },
        {
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="clickable"><a href="#details">Details</a></li>\n<li class="clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
          id: 'output-html',
          label: 'Output Html',
          readonly: true,
          type: 'html',
          uid: '56dfc210727e82c4',
        },
        {
          content: [
            {
              content:
                '<p>The Lifetime Needs Plan is designed to provide the member with the means of contributin to an investment fund which can meet the member&#39;s lifetime needs (e.g. child education, vacation, engagement, wedding etc.)</p>\n',
              id: 'system-constant',
              label: '',
              readonly: true,
              type: 'html',
              uid: '56cc7f0afaf26445',
            },
            {
              content:
                '<p>In addition, the product also provides a life cover which becomes payable in the event of the demise of the Life Assured</p>\n',
              id: 'system-constant',
              label: '',
              readonly: true,
              type: 'html',
              uid: '6096c1bd69294f4b',
            },
          ],
          id: 'product-description',
          label: 'Product Description',
          readonly: true,
          type: 'list',
          uid: '6cb8814abf4f3e42',
        },
        {
          content: [
            {
              content: '<p>What is your Date of Birth</p>\n',
              id: 'system-constant',
              label: '',
              readonly: true,
              type: 'html',
              uid: '3335dba07bda188d',
            },
            {
              component: 'DateSelector',
              content: '',
              elementType: 'input',
              errors: ['*'],
              id: 'date-of-birth',
              inputType: 'date',
              label: 'Date Of Birth',
              maxYear: thisYear,
              publishChange: true,
              readonly: false,
              type: 'component',
              uid: 'f0e0a8a867c4bd0c',
            },
          ],
          id: 'your-details',
          label: 'Your Details',
          readonly: false,
          type: 'list',
          uid: '149ba33c3dcef1de',
        },
        {
          content: [
            {
              content:
                '<p>How much would you like to invest towards the investment fund of this policy.</p>\n',
              id: 'system-constant',
              label: '',
              readonly: true,
              type: 'html',
              uid: 'efef1aaab0850759',
            },
            {
              content: '',
              elementType: 'input',
              errors: ['*'],
              id: 'monthly-contribution',
              inputType: 'number',
              label: 'Monthly Contribution',
              publishChange: true,
              readonly: false,
              type: 'amount',
              uid: '133407d258e82bd2',
            },
          ],
          id: 'investment-contribution',
          label: 'Investment Contribution',
          readonly: false,
          type: 'list',
          uid: '7db09c5f165fb4e7',
        },
        {
          content: [
            {
              content:
                '<p>Please select the level of life cover that you need in the event of you passing away</p>\n',
              id: 'system-constant',
              label: '',
              readonly: true,
              type: 'html',
              uid: '23bf2a88571920b6',
            },
            {
              content: [
                {
                  content: '',
                  elementType: 'checkbox',
                  id: 'low-cover',
                  label: 'Low Cover',
                  options: ['Y', 'N'],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'Low Cover',
                  type: 'field',
                  uid: '3d9b17c2a9ab5522',
                },
                {
                  content: '',
                  elementType: 'checkbox',
                  id: 'medium-cover',
                  label: 'Medium Cover',
                  options: ['Y', 'N'],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'Medium Cover',
                  type: 'field',
                  uid: 'fa13f26a0999a034',
                },
                {
                  content: '',
                  elementType: 'checkbox',
                  id: 'high-cover',
                  label: 'High Cover',
                  options: ['Y', 'N'],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'High Cover',
                  type: 'field',
                  uid: 'f64bb3ae9075e39d',
                },
              ],
              id: 'cover-level-radio-group',
              label: 'Cover Level Radio Group',
              errors: ['*'],
              readonly: false,
              type: 'list',
              uid: 'e72d22b6b50ae607',
            },
          ],
          id: 'life-cover-benefit',
          label: 'Life Cover Benefit',
          readonly: false,
          type: 'list',
          uid: 'b9ba86f2ce5f0866',
        },
        {
          content: [
            {
              content:
                '<p>You have the opportunity to add more optional benefits to this policy</p>\n',
              id: 'system-constant',
              label: '',
              readonly: true,
              type: 'html',
              uid: '1326ce223233225d',
            },
            {
              content: [
                {
                  content: '',
                  elementType: 'select',
                  id: 'hospitalisation-cover-option',
                  label: 'Hospitalisation Cover Option',
                  options: ['', '1', '2', '3', '4', '5'],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'Hospitalisation Cover Option',
                  type: 'amount',
                  uid: '4db9a6e0db4be9e3',
                },
              ],
              id: 'hospitalisation-cover',
              label: 'Hospitalisation Cover',
              readonly: false,
              type: 'list',
              uid: '79790cbfa2823aa8',
            },
            {
              content: [
                {
                  content: '',
                  elementType: 'input',
                  id: 'cash-bonus-premium',
                  inputType: 'number',
                  label: 'Cash Bonus Premium',
                  publishChange: true,
                  readonly: false,
                  type: 'amount',
                  uid: '773688c87ef707cc',
                },
              ],
              id: 'cash-bonus',
              label: 'Cash Bonus',
              readonly: false,
              type: 'list',
              uid: 'dd50ae7321e44835',
            },
            {
              content: [
                {
                  content:
                    '<p>Do you want to add automatic annual payment and benefit increases. If so - please select the level of payment rate increase you want to apply</p>\n',
                  id: 'system-constant',
                  label: '',
                  readonly: true,
                  type: 'html',
                  uid: '5787b5a6ee008ce2',
                },
                {
                  content: '',
                  elementType: 'select',
                  errors: ['*'],
                  id: 'update-option',
                  label: 'Update Option',
                  options: ['', '0', '5', '10', '15', '20', '25', '30'],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'Update Option',
                  type: 'field',
                  uid: '77e916be68b6a7f7',
                },
              ],
              id: 'premium-update',
              label: 'Premium Update',
              readonly: false,
              type: 'list',
              uid: 'b60431ec47460844',
            },
            {
              content: [
                {
                  content: '',
                  elementType: 'input',
                  id: 'lumpsum-contribution',
                  inputType: 'number',
                  label: 'Lumpsum Contribution',
                  publishChange: true,
                  readonly: false,
                  type: 'amount',
                  uid: '8dfedd11eb308e32',
                },
              ],
              id: 'lumpsum-contribution-item',
              label: 'Lumpsum Contribution',
              readonly: false,
              type: 'list',
              uid: 'd941997b09606288',
            },
          ],
          id: 'additional-benefits',
          label: 'Additional Benefits',
          readonly: false,
          type: 'list',
          uid: '4f604468426352fd',
        },
        {
          content: [
            {
              content: [
                {
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                  id: 'system-constant',
                  label: '',
                  readonly: true,
                  type: 'html',
                  uid: '2206bf3b026c9aab',
                },
                {
                  content: '0.00',
                  elementType: 'input',
                  id: 'benefit-rate',
                  inputType: 'number',
                  label: 'Benefit Rate',
                  readonly: true,
                  type: 'amount',
                  uid: 'f20aba0e17ed86fa',
                },
                {
                  content: '0.00',
                  elementType: 'input',
                  id: 'premium',
                  inputType: 'number',
                  label: 'Premium',
                  readonly: true,
                  type: 'amount',
                  uid: '2e71b32f3296dcea',
                },
              ],
              id: 'quotation-information',
              label: 'Quotation Information',
              readonly: true,
              type: 'list',
              uid: '199d606aae116a66',
            },
          ],
          id: 'quotation-panel',
          label: 'Quotation Panel',
          readonly: true,
          type: 'list',
          uid: '3c08cc4b6853871c',
        },
      ],
      id: 'quote-screen',
      label: 'Quote Screen',
      readonly: false,
      type: 'list',
      uid: '4962b066401bebbb',
    },
    text: [],
    title: 'Public Access \n Welcome to Elac',
    uri: 'lifetime-needs-plus/quote',
  },
  'premium-amount': {
    text: [],
    buttons: [
      {
        label: 'Done',
        id: 'done',
        uid: '4e5f7031a7643ff6',
        control: true,
      },
      {
        label: 'Need Help',
        id: 'need-help',
        uid: 'd50806d8255b18f1',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '6a934b0fa0dc1bd8',
      content: [
        ' The minimum premium is 100. Please select additional cover in order to meet this requirement.',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Quotation Details',
    uri: 'lifetime-needs-plus/quote',
    class: 'life-time-needs-quotation-details',
  },
  'personal-details': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'personal-details',
      type: 'list',
      readonly: false,
      label: 'Personal Details',
      uid: '5a7b1db11f796b39',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'c9d124707f9d1b14',
          content: '<h2 id="personal-details">Personal Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'a8902e1cd0cee07e',
          content:
            '<p>For us to complete the purchase, we require the following information</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '3dfdc74464a34aa8',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'your-details',
          type: 'list',
          readonly: false,
          label: 'Your Details',
          uid: 'a4ca8e4369d84fad',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: 'b0cb5e2013562d51',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: 'd9b3dd2f9b758c95',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'idpassport-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ID/Passport Number',
              uid: '98e2671fcd68feeb',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'id-type',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'ID Type',
              uid: '5e008fe027dbc741',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'ID Type',
              options: [
                '',
                'National ID',
                'Voters ID',
                'Passport',
                'Drivers New ID',
                'Drivers Old ID',
                'Ssnit',
                'Nhis',
              ],
            },
            {
              id: 'date-of-birth',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Date Of Birth',
              uid: 'cf5112787e541dd8',
              content: '',
              publishChange: true,
              inputType: 'date',
              maxYear: thisYear,
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: 'df961919bc248ac4',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Title',
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'marital-status',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Marital Status',
              uid: 'b7787bd9a19e2138',
              content: '',
              publishChange: true,
              tooltip: 'Marital Status',
              options: [
                '',
                'Divorced',
                'Married',
                'Single',
                'Widow',
                'Widower',
              ],
            },
            {
              id: 'nationality',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Nationality',
              uid: '81b86213b18ca43e',
              content: '',
              publishChange: true,
              tooltip: 'Nationality',
              errors: ['*'],
              options: [
                '',
                'Afghan',
                'Albanian',
                'Algerian',
                'American',
                'Andorran',
                'Angolan',
                'Argentine',
                'Armenian',
                'Aromanian',
                'Aruban',
                'Australian',
                'Austrian',
                'Azerbaijani',
                'Bahamian',
                'Bahraini',
                'Baltic German',
                'Baltic Russian',
                'Bangladeshi',
                'Barbadian',
                'Belarusian',
                'Belgian',
                'Belizean',
                'Bermudian',
                'Boer',
                'Bosniak',
                'Brazilian',
                'Breton',
                'British',
                'British Virgin Islander',
                'Bruneian',
                'Bulgarian',
                'Burkinabè',
                'Burundian',
                'Cambodian',
                'Cameroonian',
                'Canadian',
                'Cape Verdean',
                'Catalan',
                'Chadian',
                'Chilean',
                'Chinese',
                'Colombian',
                'Comorian',
                'Congolese',
                'Croatian',
                'Cuban',
                'Cypriot',
                'Czech',
                'Dane',
                'Dominican (Commonwealth)',
                'Dominican (Republic)',
                'Dutch',
                'East Timorese',
                'Ecuadorian',
                'Egyptian',
                'Emirati',
                'English',
                'Eritrean',
                'Estonian',
                'Ethiopian',
                'Falkland Islander',
                'Faroese',
                'Fijian',
                'Filipino',
                'Finn',
                'Finnish Swedish',
                'French Citizen',
                'Georgian',
                'German',
                'Ghanaian',
                'Gibraltar',
                'Greek',
                'Greek Macedonian',
                'Grenadian',
                'Guatemalan',
                'Guianese (French)',
                'Guinea Bissau National',
                'Guinean',
                'Guyanese',
                'Haitian',
                'Honduran',
                'Hong Kong',
                'Hungarian',
                'I Kiribati',
                'Icelander',
                'Indian',
                'Indonesian',
                'Iranian',
                'Iraqi',
                'Irish',
                'Israeli',
                'Italian',
                'Ivoirian',
                'Jamaican',
                'Japanese',
                'Jordanian',
                'Kazakh',
                'Kenyan',
                'Korean',
                'Kosovar',
                'Kurd',
                'Kuwaiti',
                'Kyrgyz',
                'Lao',
                'Latvian',
                'Lebanese',
                'Liberian',
                'Libyan',
                'Liechtensteiner',
                'Lithuanian',
                'Luxembourger',
                'Macedonian',
                'Macedonian Bulgarian',
                'Malagasy',
                'Malawian',
                'Malaysian',
                'Maldivian',
                'Malian',
                'Maltese',
                'Manx',
                'Mauritian',
                'Mexican',
                'Moldovan',
                'Mongolian',
                'Montenegrin',
                'Moroccan',
                'Namibian',
                'Nepalese',
                'New Zealander',
                'Nicaraguan',
                'Nigerian',
                'Nigerien',
                'Norwegian',
                'Other',
                'Pakistani',
                'Palauan',
                'Palestinian',
                'Panamanian',
                'Papua New Guinean',
                'Paraguayan',
                'Peruvian',
                'Pole',
                'Portuguese',
                'Puerto Rican',
                'Qatari',
                'Romanian',
                'Russian',
                'Rwandan',
                'Salvadoran',
                'Saudi',
                'Scot',
                'Senegalese',
                'Serb',
                'Sierra Leonean',
                'Sindhian',
                'Singaporean',
                'Slovak',
                'Slovene',
                'Somali',
                'Somalilander',
                'South African',
                'Spaniard',
                'Sri Lankan',
                'St Lucian',
                'Sudanese',
                'Surinamese',
                'Swede',
                'Swiss',
                'Syriac',
                'Syrian',
                'São Tomé And Príncipe',
                'Taiwanese',
                'Tajik',
                'Tanzanian',
                'Thai',
                'Tibetan',
                'Tobagonian',
                'Trinidadian',
                'Tunisian',
                'Turk',
                'Turkish Cypriot',
                'Tuvaluan',
                'Ugandan',
                'Ukrainian',
                'United States',
                'Uruguayan',
                'Uzbek',
                'Vanuatuan',
                'Venezuelan',
                'Vietnamese',
                'Welsh',
                'Yemeni',
                'Zambian',
                'Zimbabwean',
              ],
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Gender',
              uid: '72e95c05ec4cf91a',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Gender',
              options: ['', 'Female', 'Male'],
            },
            {
              id: 'occupation',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Occupation',
              uid: '3c0de7df15dc77b9',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Occupation',
              options: [
                '',
                'Abattoir Worker',
                'Accountant',
                'Accounting Officer',
                'Actor',
                'Actress',
                'Actuary',
                'Admin Assistant',
                'Administrator',
                'Advertising Agent',
                'Advocate',
                'Affal Washer',
                'Agriculture Assistant',
                'Agriculture Officer',
                'Air Force',
                'Air Force Ground Crew',
                'Aircraft Engineer',
                'Airline Employee',
                'Airline Executive',
                'Airline Pilot',
                'Ambulance Attendant',
                'Ambulance Driver',
                'Announcer',
                'Artisan',
                'Artist',
                'Assessor',
                'Auctioneer',
                'Auditor',
                'Author',
                'Auto Electrician',
                'Auxillary Worker',
                'Aviation',
                'Baker',
                'Bank Teller',
                'Bank-Manager',
                'Banker',
                'Bar Lady',
                'Bar Steward',
                'Barber',
                'Barmaid',
                'Barman',
                'Beautician',
                'Blacksmith',
                'Blockman',
                'Boilermaker',
                'Bookbinder',
                'Bookkeeper',
                'Bookmaker',
                'Boring Contractor',
                'Bottle Store Assistant',
                'Bottle Store Manager',
                'Boxer',
                'Bricklayer',
                'Broker',
                'Builder',
                'Building Contractor',
                'Building Foreman',
                'Building Inspector',
                'Bus Driver',
                'Butcher',
                'Buyer',
                'Cabinetmaker',
                'Cafe Owner',
                'Cameraman',
                'Cardiologist',
                'Caretaker',
                'Carpenter',
                'Carpet Layer',
                'Cashier',
                'Caterer',
                'Checker',
                'Chef',
                'Chief Officer',
                'Chiropodist',
                'Civil Defense Officer',
                'Cleaner',
                'Clergyman',
                'Clerk',
                'Cold Storage Worker',
                'Commercial Photographer',
                'Compositor-Electronic',
                'Compositor-Mechanical',
                'Computer Engineer',
                'Computer Operator',
                'Computer Programmer',
                'Computer Systems Analyst',
                'Computer Technician',
                'Conductor',
                'Constable',
                'Construction Worker',
                'Consultant',
                'Cook',
                'Copywriter',
                'Councillor',
                'Courier',
                'Cropduster',
                'Croupier',
                'Customs Official',
                'Dairy Worker',
                'Dancing Teacher',
                'Dean',
                'Demolition Worker',
                'Dental Assistant',
                'Dental Technician',
                'Dentist',
                'Detective',
                'Diamond Cutter',
                'Dietician',
                'Director',
                'Display Artist',
                'Diver',
                'Dockworker',
                'Doctor',
                'Domestic',
                'Draughtsman',
                'Dressmaker',
                'Driller',
                'Driver',
                'Dry Cleaner',
                'Economist',
                'Editor',
                'Education Inspector',
                'Educator',
                'Electrical Contractor',
                'Electrician',
                'Electronics Engineer',
                'Electroplater',
                'Employee',
                'Engineer',
                'Engineer-Qualified',
                'Engraver',
                'Entomologist',
                'Estate Agent',
                'Executive',
                'Explosives Worker',
                'Exterminator',
                'Farm Worker',
                'Farmer Foreman',
                'Farmer Manager',
                'Farmer Owner',
                'Fashion Designer',
                'Film Maker',
                'Fireman',
                'Fisherman',
                'Fitter And Turner',
                'Floor Surfacer',
                'Florist',
                'Foreman',
                'Forester',
                'Fortune Teller',
                'Foundry Manager',
                'Foundry Worker',
                'Freight Forwarder',
                'Fumigator',
                'Furnace Assistant',
                'Furnace Manager',
                'Furnace Supervisor',
                'Game Ranger',
                'Game Warden',
                'Garage Attendant',
                'Garage Owner',
                'Gardener',
                'General Assistant',
                'General Dealer',
                'General Worker',
                'Geologist',
                'Glassblower',
                'Glazier',
                'Goldsmith',
                'Grain Silo Operator',
                'Graphic Designer',
                'Greengrocer',
                'Groundsman',
                'Guard (Security)',
                'Gunsmith',
                'Hairdresser',
                'Hawker',
                'Head Of Department',
                'Headmaster',
                'Health Inspector',
                'Homeopath',
                'Horticulturist',
                'Hotel Manager',
                'Housewife',
                'Hr Assistant',
                'Inspector',
                'Insurance Agent',
                'Insurance Assessor',
                'Interior Decorator',
                'Interpreter',
                'Investigator',
                'Jeweller',
                'Jockey',
                'Joiner',
                'Journalist',
                'Labourer',
                'Lawyer',
                'Lecturer',
                'Librarian',
                'Lift Inspector',
                'Lift Operator',
                'Lift Technician',
                'Lighthouse Keeper',
                'Locksmith',
                'Machine Operator',
                'Machinist',
                'Magistrate',
                'Major',
                'Manager',
                'Manicurist',
                'Manufacturer',
                'Market Researcher',
                'Marketing Officer',
                'Martial Arts Instructor',
                'Mason',
                'Meat Inspector',
                'Mechanic',
                'Medical Representative',
                'Medical Technologist',
                'Medical-Practitioner',
                'Merchandiser',
                'Merchant Seaman',
                'Messenger',
                'Metallurgist',
                'Meter Reader',
                'Midwife',
                'Millwright',
                'Miner',
                'Minister Of Religion',
                'Model',
                'Motor Salesman',
                'Motor Spares Salesman',
                'Moulder',
                'Musician',
                'Naval Personnel',
                'Night Watchman',
                'Nurse',
                'Nurseryman',
                'Nursing Assistant',
                'Nursing Sister',
                'Occupational Therapist',
                'Officer',
                'Operator',
                'Ophthalmologist',
                'Optical Mechanic',
                'Orthopedic Orthopedist',
                'Packer',
                'Painter',
                'Painting Contractor',
                'Panelbeater',
                'Paramedic',
                'Pastor',
                'Pawnbroker',
                'Pensioner',
                'Permanent Way',
                'Personnel Officer',
                'Pest Exterminator',
                'Petrol Attendant',
                'Petroleum Refinery',
                'Pharmacist',
                'Photographer',
                'Physiotherapist',
                'Piano Tuner',
                'Pilot',
                'Plasterer',
                'Plumber',
                'Police Constable',
                'Police Woman',
                'Policeman',
                'Porter',
                'Postman',
                'Postmaster',
                'Principal',
                'Printer',
                'Prisons Personnel',
                'Private Investigator',
                'Producer',
                'Professor',
                'Programmer',
                'Property Appraiser',
                'Proprietor',
                'Public Prosecutor',
                'Public Relations Officer',
                'Quality Controller',
                'Quantity Surveyor',
                'Quarryman',
                'Racehorse Trainer',
                'Radiographer',
                'Radiologist',
                'Receptionist',
                'Religious Leader',
                'Repairman',
                'Representative',
                'Research Assistant',
                'Restaurant Owner',
                'Retired',
                'Rigger (Docks)',
                'Roadworker',
                'Sailor',
                'Sales Consultant',
                'Sales Lady',
                'Sales Support',
                'Sales Woman',
                'Salesman',
                'Seaman',
                'Seaman (Merchant)',
                'Seamstress',
                'Secretary',
                'Security Guard',
                'Self-Employed',
                'Sergeant',
                'Shedman',
                'Sheet Metal Worker',
                'Shipping Agent',
                'Shop Assistant',
                'Shop Manager',
                'Shopfitter',
                'Shunter-Foreman',
                'Signwriter',
                'Silversmith',
                'Singer',
                'Slaughterer',
                'Smelter',
                'Social Worker',
                'Soldier',
                'Sound Engineer',
                'Sportsman',
                'Sportswoman',
                'Spray Painter',
                'Sprayer',
                'Stationmaster',
                'Statistician',
                'Stevedore',
                'Steward',
                'Stock Broker',
                'Store Lady',
                'Storeman',
                'Student',
                'Supervisor',
                'Surgeon',
                'Sweeper',
                'Swimming Pool Attendant',
                'Switchboard Operator',
                'Systems Analyst',
                'Tailor',
                'Taxi Driver',
                'Teacher',
                'Technician',
                'Telegraphist',
                'Telephone Technician',
                'Telephonist',
                'Tiler',
                'Toolmaker',
                'Town Clerk',
                'Town Planner',
                'Trader',
                'Tradesman',
                'Traffic Officer',
                'Trainer',
                'Translator',
                'Travel Agent',
                'Typesetter',
                'Typist',
                'Undertaker',
                'Underwriter',
                'Unemployed',
                'Upholsterer',
                'Urologist',
                'Vetrinarian',
                'Vetrinary Surgeon',
                'Vulcaniser',
                'Waiter',
                'Waitress',
                'Warden',
                'Watch Maker',
                'Watchman',
                'Welder',
                'Well Sinker',
                'Window Cleaner',
                'Window Dresser',
                'Wood Cutter',
                'Worker',
                'Wrestler',
              ],
            },
          ],
        },
        {
          id: 'your-contact-details',
          type: 'list',
          readonly: false,
          label: 'Your Contact Details',
          uid: '7176bc80f1cc1210',
          content: [
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: '43bb2ffb6f6594b6',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'work-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Work Phone',
              uid: '35332cee5c81c2e8',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'home-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Home Phone',
              uid: '6ff7f8506395684a',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'fax',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Fax',
              uid: '55762cb3c5055b4b',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'email',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Email',
              uid: '99e501a1eafa8e29',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'email',
            },
          ],
        },
        {
          id: 'your-postal-address',
          type: 'list',
          readonly: false,
          label: 'Your Postal Address',
          uid: '2eb0075d48672657',
          content: [
            {
              id: 'life-assured-postal-address',
              type: 'list',
              readonly: false,
              label: 'Life Assured Postal Address',
              uid: '11c2de8188fd8d1b',
              content: [
                {
                  id: 'addressee',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Addressee',
                  uid: 'e301c545cb714ab7',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'po-box-or-private-bag',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'PO Box Or Private Bag',
                  uid: '438a76adb0dd6ffa',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
                {
                  id: 'area-code',
                  type: 'field',
                  elementType: 'datalist',
                  readonly: false,
                  label: 'Area Code',
                  uid: '397fc310b06a8777',
                  content: '',
                  publishChange: true,
                  options: loadOptions('397fc310b06a8777'),
                  partialOptions: true,
                  autoComplete: 'options',
                  errors: ['*'],
                },
                {
                  id: 'street',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Street',
                  uid: '14ca763eb4f00bc6',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'suburb',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Suburb',
                  uid: 'c65b69006d719e9f',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
                {
                  id: 'town',
                  type: 'field',
                  elementType: 'datalist',
                  readonly: false,
                  label: 'Town',
                  uid: '869fa1a1bea8499a',
                  content: '',
                  publishChange: true,
                  options: loadOptions('f65c4a97d4bee5a0'),
                  partialOptions: true,
                  autoComplete: 'options',
                  errors: ['*'],
                },
                {
                  id: 'region',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Region',
                  uid: '2018c28ec820aae9',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Region',
                  options: [
                    '',
                    'Ahafo',
                    'Ashanti',
                    'Bono East',
                    'Brong Ahafo',
                    'Central',
                    'Eastern',
                    'Greater Accra',
                    'North East',
                    'Northern',
                    'Oti',
                    'Savannah',
                    'Upper East',
                    'Upper West',
                    'Volta',
                    'Western',
                    'Western North',
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '321c5c3473bf90e7',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '38c4643b702dd83d',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '9d5a6984d4139224',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '58719255037788a9',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'd302a75bb5ba94db',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Personal Details',
    uri: 'lifetime-needs-plus/personal-details',
    class: 'life-time-needs-personal-details',
  },
  'spouse-details': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'spouse-details',
      type: 'list',
      readonly: false,
      label: 'Spouse Details',
      uid: 'aedaa6d21eef14d1',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '2a669ec2b7c2d500',
          content: '<h2 id="spouse-details">Spouse Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '1b69ff24ec5e56a9',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: 'e55ea46b1a371db4',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'spouse-identification',
          type: 'list',
          readonly: false,
          label: 'Spouse Identification',
          uid: '5e124f3d69df1faa',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: 'e56d649f329f8900',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: '06edb783e92ec333',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: '189ba9973d67c117',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Title',
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'marital-status',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Marital Status',
              uid: '5bc24b9435dfcfdb',
              content: 'Married',
              inputType: 'text',
            },
            {
              id: 'id-type',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'ID Type',
              uid: '3fd44e91749bf50a',
              content: '',
              publishChange: true,
              tooltip: 'ID Type',
              options: [
                '',
                'National ID',
                'Voters ID',
                'Passport',
                'Drivers New ID',
                'Drivers Old ID',
                'Ssnit',
                'Nhis',
              ],
            },
            {
              id: 'idpassport-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ID/Passport Number',
              uid: '9c9c0bc2cfd92530',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: '5c9aa3099fa760a5',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'date',
              component: 'DateSelector',
              maxYear: thisYear,
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Gender',
              uid: '46c535151fcf7a9a',
              content: '',
              inputType: 'text',
            },
          ],
        },
        {
          id: 'spouse-contact-details',
          type: 'list',
          readonly: false,
          label: 'Spouse Contact Details',
          uid: '7a5a01e07b4451cf',
          content: [
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: '793b72cc789f651d',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'work-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Work Phone',
              uid: '147c369ae58de9af',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'home-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Home Phone',
              uid: '194bbd1fc2548543',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
          ],
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '105c42d70fbd4e0d',
          content: '<p>Specify your spouse to be the trustee of the plan</p>\n',
        },
        {
          id: 'spouse-is-trustee',
          type: 'field',
          elementType: 'checkbox',
          readonly: false,
          label: 'Spouse Is Trustee',
          uid: '6b58669450576bf8',
          content: '',
          publishChange: true,
          tooltip: 'Spouse Is Trustee',
          options: ['Y', 'N'],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '00c3ec0a291cc87d',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '686752c9d4043594',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'a5383d948f849ea2',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'fb1199946800cace',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'a4988c3d7f1e31ea',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Spouse Details',
    uri: 'lifetime-needs-plus/spouse-details',
    class: 'life-time-needs-spouse-details',
  },
  'trustee-details': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'trustee-details',
      type: 'list',
      readonly: false,
      label: 'Trustee Details',
      uid: 'b03347166c0ba62c',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'c57d8cad196453a3',
          content: '<h2 id="trustee-details">Trustee details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53952a550bf734cc',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '8ac4d130f3be0edd',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'trustee-identification',
          type: 'list',
          readonly: false,
          label: 'Trustee Identification',
          uid: '842ffef78545f0cf',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: 'fffa2dcbe12ce9d3',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: '981afeb77aef71b6',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: '8c3344fe2f04f1c2',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'date',
              component: 'DateSelector',
              maxYear: thisYear,
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: '10e4727a0b4bd062',
              content: '',
              publishChange: true,
              tooltip: 'Title',
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'marital-status',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Marital Status',
              uid: 'd5f39f372e438d24',
              content: '',
              publishChange: true,
              tooltip: 'Marital Status',
              options: [
                '',
                'Divorced',
                'Married',
                'Single',
                'Widow',
                'Widower',
              ],
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Gender',
              uid: 'a67a1833a0e4d00f',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Gender',
              options: ['', 'Female', 'Male'],
            },
            {
              id: 'id-type',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'ID Type',
              uid: '40586bd062f77cd8',
              content: '',
              publishChange: true,
              tooltip: 'ID Type',
              options: [
                '',
                'National ID',
                'Voters ID',
                'Passport',
                'Drivers New ID',
                'Drivers Old ID',
                'Ssnit',
                'Nhis',
              ],
            },
            {
              id: 'idpassport-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ID/Passport Number',
              uid: '72ed1903f31f2e59',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
          ],
        },
        {
          id: 'trustee-contact-details',
          type: 'list',
          readonly: false,
          label: 'Trustee Contact Details',
          uid: '3ec8f69398b11434',
          content: [
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: '0cb29f45f8a74330',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'work-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Work Phone',
              uid: 'a812c291e3329674',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'home-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Home Phone',
              uid: '19209270783ab20e',
              content: '',
              publishChange: true,
              inputType: 'tel',
              component: 'PhoneNumber',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '7774fec5f25a74cd',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '7ae0669ad445b012',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'a0622498b3dd7874',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '19759474a887a51d',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '3aa22fa32e1f6ecd',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Trustee Details',
    uri: 'lifetime-needs-plus/trustee-details',
    class: 'life-time-needs-trustee-details',
  },
  'beneficiary-details': {
    text: [],
    buttons: [
      {
        label: 'Add Trustee',
        id: 'add-trustee',
        uid: '1c40f26fba6a8711',
        control: false,
      },
      {
        label: 'Add another Beneficiary',
        id: 'add-another-beneficiary',
        uid: '8c70adfc3edd44ca',
        control: false,
      },
      {
        label: 'Update Benefit Split Percentage',
        id: 'update-benefit-split-percentage',
        uid: '6ce12a7a32a8d69a',
        control: false,
      },
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'specify-beneficiaries',
      type: 'list',
      readonly: true,
      label: 'Specify Beneficiaries',
      uid: '124fb2b37943a476',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'ccd1e945cd5c3045',
          content: '<h2 id="beneficiary-details">Beneficiary Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f0d387b3ecd49ed5',
          content: '<p>Please specify your beneficiary details below</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: 'f46ff380717f1288',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: '6c60b1c422ae8373',
          content:
            '<p><a href="#add-trustee">Add Trustee as beneficiary</a></p>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '145b199f80e0c8c3',
          content:
            '<p><a href="#add-another-beneficiary">Add a different beneficiary</a></p>\n',
        },
        {
          id: 'beneficiary-details',
          type: 'table',
          readonly: true,
          label: 'Beneficiary Details',
          uid: 'bda0211f592e14e3',
          triggers: ['DoubleClick'],
          content: [],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'd5098c781b5757a2',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'ddc7ef8198cf5e93',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'b8753e9d49ed9aff',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '56fbca3413111385',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '73d064eb1a0df579',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Beneficiary Details',
    uri: 'lifetime-needs-plus/beneficiary-details',
    class: 'life-time-needs-beneficiary-details',
  },
  'add-beneficiary': {
    modal: true,
    text: [],
    buttons: [
      { label: 'Add', id: 'add', uid: '1413145eedf0be58', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
    ],
    item: {
      id: 'beneficiary-details',
      type: 'list',
      readonly: false,
      label: 'Beneficiary Details',
      uid: '6a3f5c79557ccfa0',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '94e325bd80270712',
          content:
            '<p>Please provide the following information for the beneficiary you would like to add to the policy</p>\n',
        },
        {
          id: 'first-names',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'First Names',
          uid: 'e094a59185798ed1',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'surname',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'Surname',
          uid: 'd7eda3e624e178e2',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'role',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Role',
          uid: '8ca3d9f9ca35bf9f',
          content: '',
          publishChange: true,
          tooltip: 'Role',
          options: [
            '',
            'Brother',
            'Child',
            'Cousin',
            'Daughter',
            'Family',
            'Father',
            'Father-in-law',
            'Grandchild',
            'Grandfather',
            'Grandmother',
            'Main',
            'Mother',
            'Mother-in-law',
            'Nephew',
            'Niece',
            'Sister',
            'Son',
            'Spouse',
            'Step-Father',
            'Step-Mother',
          ],
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Gender',
          uid: '09f28932184006c8',
          content: '',
          publishChange: true,
          errors: ['*'],
          tooltip: 'Gender',
          options: ['', 'Female', 'Male'],
        },
        {
          id: 'date-of-birth',
          type: 'component',
          elementType: 'input',
          readonly: false,
          label: 'Date Of Birth',
          uid: '6b9a4f659b85294a',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'date',
          component: 'DateSelector',
          maxYear: thisYear,
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Beneficiary Details Add',
    uri: 'application/beneficiary-details/add',
    class: 'beneficiary-details-add',
  },
  'edit-beneficiary': {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Delete Beneficiary',
        id: 'delete-beneficiary',
        uid: '02308b457a7dc6a3',
        control: false,
      },
      { label: 'Update', id: 'update', uid: 'd8035e4553f65492', control: true },
    ],
    item: {
      id: 'beneficiary-details',
      type: 'list',
      readonly: false,
      label: 'Beneficiary Details',
      uid: '0eafb4fa265b4de8',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '7fa0e505ce6ab73a',
          content:
            '<p>Edit beneficiary information below or <a href="#delete-beneficiary">click here to remove beneficiary</a>.</p>\n',
        },
        {
          id: 'first-names',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'First Names',
          uid: 'e094a59185798ed1',
          content: '',
          publishChange: true,
          inputType: 'text',
        },
        {
          id: 'surname',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'Surname',
          uid: 'd7eda3e624e178e2',
          content: '',
          publishChange: true,
          inputType: 'text',
        },
        {
          id: 'role',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Role',
          uid: '8ca3d9f9ca35bf9f',
          content: '',
          publishChange: true,
          tooltip: 'Role',
          options: [
            '',
            'Cessionary',
            'Brother',
            'Child',
            'Cousin',
            'Daughter',
            'Family',
            'Father',
            'Father-in-law',
            'Grandchild',
            'Grandfather',
            'Grandmother',
            'Main',
            'Mother',
            'Mother-in-law',
            'Nephew',
            'Niece',
            'Sister',
            'Son',
            'Spouse',
            'Step-Father',
            'Step-Mother',
          ],
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Gender',
          uid: '09f28932184006c8',
          content: 'Female',
          publishChange: true,
          tooltip: 'Gender',
          options: ['', 'Female', 'Male'],
        },
        {
          id: 'date-of-birth',
          type: 'component',
          elementType: 'input',
          readonly: false,
          label: 'Date Of Birth',
          uid: '6b9a4f659b85294a',
          content: '',
          publishChange: true,
          inputType: 'date',
          component: 'DateSelector',
          maxYear: thisYear,
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Beneficiary Details Edit',
    uri: 'application/beneficiary-details/edit',
    class: 'beneficiary-details-edit',
  },
  'update-beneficiary-split-percentage': {
    modal: true,
    text: [],
    buttons: [
      { label: 'Update', id: 'update', uid: 'd8035e4553f65492', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
    ],
    item: {
      id: 'update-benefit-split-percentage',
      type: 'list',
      readonly: false,
      label: 'Update Benefit Split Percentage',
      uid: '8403abf5353270c2',
      content: [],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Beneficiary Details Split',
    uri: 'application/beneficiary-details/split',
    class: 'beneficiary-details-split',
  },
  'medical-underwriting': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'medical-declaration',
      type: 'list',
      readonly: false,
      label: 'Medical Declaration',
      uid: '2f71304066981e09',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'edeb9bb462e75465',
          content: '<h2 id="medical-underwriting">Medical Underwriting</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '8cb5b9f7f893ab25',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '7dd45a20ec98eb62',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'inputs',
          type: 'list',
          readonly: false,
          label: 'Inputs',
          uid: '975766ec7c8999c5',
          content: [
            {
              id: 'question-one',
              type: 'list',
              readonly: false,
              label: 'Question One',
              uid: '574187970de7d3be',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'adde3c4498bb38dc',
                  content:
                    '<ol>\n<li>Are you presently in good health, free from disease and injuries and still have full use of your limbs and eyes?</li>\n</ol>\n',
                },
                {
                  id: 'presently-in-good-health',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Presently In Good Health',
                  uid: '8ea1033695308a89',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-two',
              type: 'list',
              readonly: false,
              label: 'Question Two',
              uid: 'aa02fc5c537194e6',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '45699498615ba20e',
                  content:
                    '<ol start="2">\n<li>Does your occupation, hobbies or pastimes involve you in any activity which may expose you to higher than average chance of premature death or becoming disabled?</li>\n</ol>\n',
                },
                {
                  id: 'risky-occupation-hobbies',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Risky Occupation Hobbies',
                  uid: '8cf7823cd5b86c1a',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-three',
              type: 'list',
              readonly: false,
              label: 'Question Three',
              uid: 'd4f0ba729dfbf24c',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'ddfd6be74618ad99',
                  content:
                    '<ol start="3">\n<li>In the past five years have you been examined by a doctor or been in hospital for treatment or examination or have you in the past or are you currently taking any drugs or prescripted medicine?</li>\n</ol>\n',
                },
                {
                  id: 'taking-prescriptions',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Taking Prescriptions',
                  uid: '9a0d0a79eda1ff85',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-four',
              type: 'list',
              readonly: false,
              label: 'Question Four',
              uid: '23af401bb703ceb8',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'b5e49ba03bd4d797',
                  content:
                    '<ol start="4">\n<li>Have you ever been tested for or receive medical advice, counselling or treatment in connection with any sexually transmitted disease?</li>\n</ol>\n',
                },
                {
                  id: 'sexually-transmitted-diseases',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Sexually Transmitted Diseases',
                  uid: '808312aef133eb1d',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-five',
              type: 'list',
              readonly: false,
              label: 'Question Five',
              uid: 'b44330b0817ae498',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '6009fbcbf17490bc',
                  content:
                    '<ol start="5">\n<li>Has any Life Assurer ever refused an application on your life or changed an increased premoum for health or occupational reasons?</li>\n</ol>\n',
                },
                {
                  id: 'refused-application-or-increased-premium',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Refused Application Or Increased Premium',
                  uid: '3785ed19997787ea',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-six',
              type: 'list',
              readonly: false,
              label: 'Question Six',
              uid: '1ae7f753e31eeb86',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '5b34d44c1f25a10c',
                  content:
                    '<ol start="6">\n<li>Is there a history in your family of diabetes, raised cholesterol, heart disease, stroke, high blood pressure, nervous or mental disorder, cancer, retinitis, pigmentosa, prophyria, haemophilia, or any pther hereditary disease?</li>\n</ol>\n',
                },
                {
                  id: 'hereditary-diseases',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Hereditary Diseases',
                  uid: '24bb2f7ff347bb67',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-seven',
              type: 'list',
              readonly: false,
              label: 'Question Seven',
              uid: '9cd72559df35a0a6',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'fa54d746c845b469',
                  content:
                    '<ol start="7">\n<li>Height (without shoes) in centimeters?</li>\n</ol>\n',
                },
                {
                  id: 'height-in-cm',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Height In Cm',
                  uid: '84a3f1fff54d81a4',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'number',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '8e7a871fb728e08d',
                  content: '<p>Weight (in normal clothes) in kilograms?</p>\n',
                },
                {
                  id: 'weight-in-kg',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Weight In Kg',
                  uid: '80c7fb04b471f096',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'number',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '4e3ed91918dc6fd1',
                  content:
                    '<p>Has your weight changed by more than 5 kilograms in the past year?</p>\n',
                },
                {
                  id: 'weight-change',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Weight Change',
                  uid: '423fc444155329c1',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-eight',
              type: 'list',
              readonly: false,
              label: 'Question Eight',
              uid: '8a4919ee75b6e739',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '2d3ce96630905843',
                  content:
                    '<ol start="8">\n<li>Alchohol Consumption</li>\n</ol>\n',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '619538ec7e04646c',
                  content:
                    '<p>How many 340ml beers do you drink per week?</p>\n',
                },
                {
                  id: 'beers-per-week',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Beers Per Week',
                  uid: '9b89a3b6204d5fb3',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '84b7968565e46111',
                  content:
                    '<p>How many glasses of wine do you drink per week?</p>\n',
                },
                {
                  id: 'wine-per-week',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Wine Per Week',
                  uid: '7f411d6b6ed47185',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '4401fb9c25007bb0',
                  content:
                    '<p>What is the total of spirits you drink per week?</p>\n',
                },
                {
                  id: 'total-weekly-spirits',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Total Weekly Spirits',
                  uid: '76506f34f8091964',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'b8ba075c9524039b',
                  content: '<p>Did you ever drink more in the past?</p>\n',
                },
                {
                  id: 'alcohol-past-consumption',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Alcohol Past Consumption',
                  uid: '9a53cea770aaf399',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Alcohol Past Consumption',
                  options: ['', 'No', 'Yes'],
                },
              ],
            },
            {
              id: 'question-nine',
              type: 'list',
              readonly: false,
              label: 'Question Nine',
              uid: 'e1eecb7cdd5a32e3',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd44dcae6e0b4d06d',
                  content: '<ol start="9">\n<li>Smoking</li>\n</ol>\n',
                },
                {
                  id: 'smoker',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Smoker',
                  uid: 'fc1101ea181446ab',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Smoker',
                  options: ['', 'Yes', 'No'],
                },
                {
                  content: [
                    {
                      content: '<p>How much do you smoke per day?</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: '3f972d4c2c73dec0',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'smoking-per-day',
                      inputType: 'text',
                      label: 'Smoking Per Day',
                      publishChange: true,
                      readonly: false,
                      type: 'field',
                      uid: '83e7175d39562088',
                    },
                    {
                      content: '<p>What do you smoke?</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: 'a2f544e74ade7011',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'smoking-preference',
                      inputType: 'text',
                      label: 'Smoking Preference',
                      publishChange: true,
                      readonly: false,
                      type: 'field',
                      uid: 'cb516706436a7f9b',
                    },
                  ],
                  id: 'smoking-details-list',
                  label: 'Smoking Details',
                  readonly: false,
                  type: 'list',
                  uid: '2810a1742a7cdbd3',
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '0f193b2b239111d0',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '97907d2e15113773',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '88ae42c7ada682d6',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '3428f9107b3e1281',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'd3b718fa91ff280e',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Underwriting',
    uri: 'lifetime-needs-plus/underwriting',
    class: 'life-time-needs-underwriting',
  },
  'health-descriptions': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'health-descriptions',
      type: 'list',
      readonly: false,
      label: 'Health Descriptions',
      uid: 'fed88f569f729c85',
      content: [],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Health Details',
    uri: 'lifetime-needs-plus/health-details',
    class: 'life-time-needs-health-details',
  },
  'payment-details': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: '776569d29bebf781',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2 id="payment-details">Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '373c5662bc08cf41',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#additional">Additional</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="done clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'payment-method',
          type: 'list',
          readonly: false,
          label: 'Payment Method',
          uid: '10b84ec2f10c4bfb',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'b3820d390c57590c',
              content: '<p>Choose a payment method</p>\n',
            },
            {
              id: 'payment-method-radio-group',
              type: 'list',
              readonly: false,
              label: 'Payment Method Radio Group',
              uid: 'e0c507cd9659cdce',
              content: [
                {
                  id: 'debit-order',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Debit Order',
                  uid: '66026bce0175bd85',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Debit Order',
                  options: ['Y'],
                },
                {
                  id: 'stop-order',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Stop Order',
                  uid: 'addc4bc1f4c832eb',
                  content: '',
                  publishChange: true,
                  tooltip: 'Stop Order',
                  options: ['Y'],
                },
              ],
            },
          ],
        },
        {
          id: 'payment-commencement',
          type: 'list',
          readonly: false,
          label: 'Payment Commencement',
          uid: 'c8333f3bb779bbad',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'a50540585ca12c07',
              content: '<p>Choose the payment start date</p>\n',
            },
            {
              id: 'payment-start-date',
              type: 'integer',
              elementType: 'select',
              readonly: false,
              label: 'Payment Start Date',
              uid: 'cd4537bfa3fb5f7d',
              content: '20191201',
              publishChange: true,
              tooltip: 'Payment Start Date',
              options: ['', '20191201', '20200101', '20200201'],
            },
          ],
        },
        {
          id: 'payer-person',
          type: 'list',
          readonly: false,
          label: 'Payer Person',
          uid: 'ce35234c9c489acc',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'ee7c49bb35030b57',
              content: '<p>Who will be paying for this policy?</p>\n',
            },
            {
              id: 'payer-person-radio-group',
              type: 'list',
              readonly: false,
              label: 'Payer Person Radio Group',
              uid: '2c1019491493ebab',
              content: [
                {
                  id: 'myself',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Myself',
                  uid: '4d7d4200a4fd7585',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'my-spouse',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'My Spouse',
                  uid: '6198ae13e0925e88',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '94903f65f4896769',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'b6a0fbc88aef4a50',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '7c7b941288238d47',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Payment Details',
    uri: 'lifetime-needs-plus/quote',
    class: 'life-time-needs-payment-details',
  },
  'debit-order-details': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: 'fc636eb02c884fb3',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2 id="payment-details">Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '373c5662bc08cf41',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#additional">Additional</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="done clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'debit-order-details',
          type: 'list',
          readonly: false,
          label: 'Debit Order Details',
          uid: '34bd098edfd4593c',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '82bc4d510e05f52c',
              content: '<p>Complete the following details</p>\n',
            },
            {
              id: 'new-account-details',
              type: 'list',
              readonly: false,
              label: 'New Account Details',
              uid: 'cd16c216c5df2fe3',
              content: [
                {
                  id: 'account-holder-name',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Account Holder Name',
                  uid: '039eb80e4a10de79',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
                {
                  id: 'account-type',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Type',
                  uid: 'fbdc797b84a0f751',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Account Type',
                  options: ['', 'Current', 'Savings'],
                },
                {
                  id: 'account-entity-name',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Entity Name',
                  uid: '41ac2dfe1beb4c8d',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Account Entity Name',
                  options: [
                    '',
                    'Absa (gh) Ltd',
                    'Access Bank Ghana Ltd',
                    'Agricultural Development Bank',
                    'Bank Of Africa',
                    'Cal Bank Ltd',
                    'Consolidated Bank Ghana',
                    'Ecobank Ghana Ltd',
                    'Fidelity Bank Ghana',
                    'First Atlantic Bank Ltd',
                    'First Bank Nigeria',
                    'Gcb Bank Ltd',
                    'Guaranty Trust (gh) Ltd',
                    'National Investment Bank',
                    'Omni Bank Ghana Ltd',
                    'Prudential Bank Ltd',
                    'Republic Bank (gh) Ltd',
                    'Societe General Ghana Ltd',
                    'Stanbic Bank Ghana Ltd',
                    'Standard Chartered Bank',
                    'United Bank For Africa (gh) Ltd',
                    'Universal Merchant Bank (gh) Ltd',
                    'Zenith Bank',
                  ],
                },
                {
                  id: 'account-branch-name',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Branch Name',
                  uid: '503a71583f1182e2',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Account Branch Name',
                  options: [
                    '',
                    '1ST LIGHT',
                    '31ST DECEMBER MARKET',
                    'A & C MALL',
                    'A & C SHOPPING MAIL',
                    'A AND C',
                    'A AND C MALL',
                    'A COMMUNITY BANK LTD-LA',
                    'A RURAL BANK LTD-AMASAMAN',
                    'A&C MALL',
                    'AA ASANTEWAA RURAL BANK LTD',
                    'AARA RURAL BANK LTD-PAGA',
                    'AASEMAN RURAL BANK LTD-KAASE',
                    'ABBOSEY OKAI',
                    'ABBOSEY OKAI BRANCH',
                    'ABEKA',
                    'ABEKA BRANCH',
                    'ABEKA LAPAZ',
                    'ABEKA LAPAZ BRANCH',
                    'ABEKALAPAZ',
                    'ABELENKPE',
                    'ABETIFI',
                    'ABETIFI BRANCH',
                    'ABII NATIONAL SAVINGS AND LOANS LTD',
                    'ABN-50129-TEMA COMMUNITY 9',
                    'ABOABO',
                    'ABOABO MARKET TAMALE',
                    'ABOKOBI RURAL BANK LTD-ABOKOBI',
                    'ABOR',
                    'ABORA',
                    'ABOSEY OKAI',
                    'ABOSSEY OKAI',
                    'ABOSSEY OKINE',
                    'ABREPO JUNCTION',
                    'ABREPO JUNCTION BRANCH',
                    'ABREPO MAIN',
                    'ABREPO MAIN BRANCH',
                    'ABUAKWA',
                    'ABUAKWA BRANCH',
                    'ABURA DUNKWA',
                    'ABURI',
                    'ABZUGU RURAL BANK LTD',
                    'ACCCRA NEWTOWN',
                    'ACCION',
                    'ACCRA',
                    'ACCRA & MAKOLA',
                    'ACCRA BRANCH',
                    'ACCRA CENTRAL',
                    'ACCRA CENTRAL POST',
                    'ACCRA CENTRAL POSTBANK',
                    'ACCRA CORPORATE SERVICE CENTRE',
                    'ACCRA MAIN',
                    'ACCRA MALL',
                    'ACCRA NEW TOWN',
                    'ACCRA SHOPPING MAIL',
                    'ACCRA SHOPPING MALL',
                    'ACHIASE',
                    'ACHIMOTA',
                    'ACHIMOTA BRANCH',
                    'ACHIMOTA MILE 7',
                    'ACTION CHAPEL',
                    'ADA FOAH',
                    'ADA RURAL BANK LTD-KASSEH',
                    'ADABOKROM',
                    'ADABRAKA',
                    'ADABRAKA BRANCH',
                    'ADANSI RURAL BANK LTD-FOMENA',
                    'ADAWSO',
                    'ADB HOUSE',
                    'ADB HOUSE BRANCH',
                    'ADEHYEMAN SAVINGS & LOAN',
                    'ADEHYEMAN SAVINGS AND LOANS',
                    'ADENTA',
                    'ADENTA BRANCH',
                    'ADENTA MARKET',
                    'ADENTAN',
                    'ADI HARBOUR',
                    'ADIAKIO WAYA',
                    'ADIDOME',
                    'ADJABENG',
                    'ADJIRINGANOR',
                    'ADONTEN COMMUNITY BANK LTD-NEW TAFO',
                    'ADUM',
                    'ADUM BRANCH',
                    'ADUM POST',
                    'ADUMAN RURAL BANK LTD-BADU',
                    'ADUM-KUMASI',
                    'AFANA RURAL BANK LTD-SAMPA',
                    'AFFUL NKWANTA',
                    'AFFUL NKWANTA BRANCH',
                    'AFLAO',
                    'AFRAM RURAL BANK LTD-TEASE',
                    'AFRANSIE',
                    'AGAVE RURAL BANK LTD-DABALE',
                    'AGBOBLOSHIE',
                    'AGBOGBLOSHIE',
                    'AGBOGBOLSHIE',
                    'AGBOZUME',
                    'AGOGO',
                    'AGONA ABREM',
                    'AGONA AHANTA',
                    'AGONA ASHANTI',
                    'AGONA NKWANTA',
                    'AGONA RURAL BANK LTD-KWANYAKU',
                    'AGONA SWEDRU',
                    'AHAFO ANO PREMIER RURAL BANK LTD-WIOSO',
                    'AHAFO COMMUNITY RURAL BANK LTD-KUKUOM',
                    'AHANTAMAN RURAL BANK LTD-AGONA NKWANTA',
                    'AHINSAN KUMASI',
                    'AHODWO',
                    'AHODWO BRANCH',
                    'AIRPORT',
                    'AIRPORT BRANCH',
                    'AIRPORT CITY',
                    'AIRPORT CITY BRANCH',
                    'AIRPORT EAST',
                    'AIYINASE',
                    'AJUMAKO',
                    'AKASTI',
                    'AKATAKYIMAN RURAL BANK LTD-KOMENDA',
                    'AKATSI',
                    'AKIM ABENASE',
                    'AKIM ADUASA',
                    'AKIM BOSOME RURAL BANK LTD-AKIM SWEDRU',
                    'AKIM ODA',
                    'AKIM SWEDRU',
                    'AKOFO HOUSE',
                    'AKONTOMBRA',
                    'AKOSOMBO',
                    'AKOSOMBO BRANCH',
                    'AKOTI RURAL BANK LTD-ASSIN AKROPONG',
                    'AKROFUOM AREA RURAL BANK LTD-AKROFUOM',
                    'AKROPONG',
                    'AKROPONG AKWAPIM',
                    'AKROSO',
                    'AKUAPEM RURAL BANK LTD-MAMFE',
                    'AKUM RURAL BANK LTD-ELMINA',
                    'AKUMADAN',
                    'AKUSE',
                    'AKWADUM',
                    'AKWATIA',
                    'AKWETEYMAN',
                    'AKYEM MANSA RURAL BANK LTD-AYIREBI',
                    'AKYEPIM RURAL BANK LTD-GOMOA-DAW',
                    'ALABAR',
                    'ALABAR BRANCH',
                    'ALPHA CAPITAL SAVING&L LTD',
                    'AMAKOM',
                    'AMAKOM BRANCH',
                    'AMANANO RURAL BANK LTD-NYINAHIM',
                    'AMANTEN',
                    'AMASAMAN',
                    'AMASIE WEST RURAL BANK LTD-ANTOAKROM',
                    'AMATIN AND KASEI COMMUNITY BANK LTD-KASEI',
                    'AMENFIMAN RURAL BANK LTD-WASSA AKROPONG',
                    'AMERICAN HOUSE BRANCH',
                    'AMFIE RURAL BANK LTD-WAMFIE',
                    'ANDOM RURAL BANK LTD-NANDOM',
                    'ANGBE RURAL BANK LTD-PRAMPRAM',
                    'ANKOBRA WEST (ESIAMA) RURAL BANK LTD-ESIAMA',
                    'ANLO RURAL BANK LTD-ANLOGA',
                    'ANLOGA',
                    'ANSOMAN RURAL BANK LTD-MANSO-AMENFI',
                    'ANTEAKWA RURAL BANK LTD-KOFORIDUA',
                    'ANUM APAPAM',
                    'ANUM RURAL BANK LTD-ANUM',
                    'ANYA KROBO RURAL BANK LTD-ODUMASE-KROBO',
                    'ANYAA',
                    'ANYAA MARKET BRANCH',
                    'ANYINAM',
                    'APAM',
                    'APENKWA',
                    'APENKWA BRANCH',
                    'APEX BANK - BOLGA CENTRE-BOLGATANGA',
                    'APEX BANK - CAPE COASTCAPE COAST',
                    'APEX BANK - TAMALE CENTRE-TAMALE',
                    'APEX BANK -HEAD OFFICE-SOUTH RIDGE ACCRA',
                    'APEX BANK -HOHOE CENTRE-HOHOE',
                    'APEX BANK KOFORIDUA CENTRE-KOFORIDUA',
                    'APEX BANK -SUNYANI CENTRE-SUNYANI',
                    'APEX BANK -WA CENTRE-WA',
                    'APEX BANKACCRA CENTRE-ACCRA',
                    'APEX BANK-HO CENTRE-HO',
                    'APEX BANK-KUMASIKUMASI',
                    'APEX BANK-TAKORADI CENTRE-TAKORADI',
                    'APEX LINK CENTRE-CEDI HOUSE',
                    'APITAL RURAL BANK LTD-ABESIM',
                    'APLAKU',
                    'APRA RURAL BANK LTD-PRANG',
                    'ARENA BRANCH',
                    'ASAFO',
                    'ASAFO BRANCH',
                    'ASAFO MARKET',
                    'ASAMANKESE',
                    'ASANKRAGUA',
                    'ASANKRAGWA',
                    'ASANTE AKYEM RURAL BANK LTD-JUANSA',
                    'ASAWINSO BRANCH',
                    'ASAWINSO RURAL BANK LTD-SEFWI-ASAWINSO',
                    'ASEBU',
                    'ASEMKROM',
                    'ASEMPANEYE',
                    'ASH TOWN',
                    'ASHAIMAN',
                    'ASHAIMAN BRANCH',
                    'ASHAIMAN LEBABNON',
                    'ASHAIMAN MAIN BRANCH',
                    'ASHAIMAN ROUND ABOUT BRANCH',
                    'ASHALLEY BOTWE BRANCH',
                    'ASHANTI BEKWAI',
                    'ASHANTI MAMPONG',
                    'ASHIAMAN',
                    'ASHIYEA BRANCH',
                    'ASHTOWN',
                    'ASHTOWN BRANCH',
                    'ASHTOWN EAST',
                    'ASHTOWN EAST BRANCH',
                    'ASIAKWA',
                    'ASIKUMA',
                    'ASOKORE RURAL BANK LTD-ASOKRE',
                    'ASOKWA',
                    'ASOKWA BRANCH',
                    'ASSIN FOSO',
                    'ASSIN FOSU',
                    'ASSIN FOSU POST',
                    'ASSINMAN RURAL BANK LTD-ASSIN MANSO',
                    'AST MANPRUSI COMMUNITY BABK LTD-GAMBAGA',
                    'ASTERN GOMOA ASSIN RURAL BANK LTD-GOMOA-DOMINASE',
                    'ASUBONTEN RURAL BANK LTD-WORAWORA',
                    'ASUOGYAMAN RURAL BANK LTD-ACCRA',
                    'ASUOPRA RURAL BANK LTD-AFOSU',
                    'ASUTIFI RURAL BANK LTD-ACERENSUA',
                    'ASUTUARE',
                    'ASYLUM DOWN',
                    'ATAABADZE',
                    'ATEBUBU',
                    'ATIWA RURAL BANK',
                    'ATIWA RURAL BANK LTD-KWABENG',
                    'ATOMIC BRANCH',
                    'ATOMIC JUNCTION BRANCH',
                    'ATONSU',
                    'ATONSU BRANCH',
                    'ATWEABAN RURAL BANK LTD-SUNYANI',
                    'ATWIMA KWANWOMA RURAL BANK LTD-PAKYI NO. 2',
                    'ATWIMA MPONUA RURAL BANK LTD-TOASE',
                    'ATWIMA RURAL BANK LTD-FOASE',
                    'AVENOR RURAL BANK LTD-AKATSI',
                    'AVENUE CENTRAL',
                    'AWASO',
                    'AWJIASE AREA RURAL BANK LTD-AWUTU BAWJIASE',
                    'AWRA RURAL BANK LTD-WA',
                    'AWUTU',
                    'AWUTU EMASA RURAL BANK LTD-AWUMASA',
                    'AXIM',
                    'AXIM ROAD BRANCH',
                    'AYANFURI',
                    'AYETEPA',
                    'AYIREBI',
                    'AYOMSO',
                    'BAATSONA',
                    'BAATSONA BRANCH',
                    'BADUKROM',
                    'BADUMAN RURAL BANK LTD-BADU',
                    'BAMAHU',
                    'BANDA NKWANTA',
                    'BANTAMA',
                    'BANTAMA 1',
                    'BANTAMA BRANCH',
                    'BANTAMA GNTC BRANCH',
                    'BASYONDE',
                    'BATSONA BRANCH',
                    'BAWALESHIE',
                    'BAWDJIASE',
                    'BAWJIASE AREA RURAL BANK LTD-AWUTU BAWJIASE',
                    'BAWKU',
                    'BAWKU BRANCH',
                    'BCM',
                    'BECHEM',
                    'BEGORO',
                    'BEIGE CAPITAL',
                    'BEKWAI',
                    'BEPOSO',
                    'BEREKUM',
                    'BESEASE',
                    'BESSFA RURAL BANK LTD-GARU',
                    'BESTPOINT SAVINGS AND LOANS',
                    'BEYIN',
                    'BI RURAL BANK LTD-HOHOE',
                    'BIA DEBISO',
                    'BIA-TORYA RURAL BANK LTD-BONSU-NKWANTA',
                    'BIBIANI',
                    'BIMBILLA',
                    'BINABA',
                    'BIRIWA',
                    'BOGOSO',
                    'BOGOSU',
                    'BOINSO',
                    'BOKOBI RURAL BANK LTD-ABOKOBI',
                    'BOLE',
                    'BOLE BRANCH',
                    'BOLGA COMMERCIAL ROAD BRANCH',
                    'BOLGA POLICE STATION ROAD BRANCH',
                    'BOLGA POST',
                    'BOLGA POSTBANK',
                    'BOLGATANGA',
                    'BOMAA AREA RURAL BANK LTD-BOMAA',
                    'BOMOSADU RURAL BANK LTD',
                    'BOND SAVINGS AND LOANS',
                    'BONGO',
                    'BONGO RURAL BANK LTD-BOLGATANGA',
                    'BONSO NKWANTA',
                    'BONSU NKWANTA',
                    'BONTRASE',
                    'BONZALI RURAL BANK LTD-KUMBUNGU',
                    'BORIMANGA RURAL BANK LTD-SAVELEGU',
                    'BOSOME FREHO RURAL BANK LTD-KUMASI',
                    'BOSOMTWI RURAL BANK LTD-KUNTANASE',
                    'BOUNDARY ROAD',
                    'BRAKWA BRAMAN RURAL BANK LTD-BRAKWA',
                    'BREEZE EAST LEGON',
                    'BREMAN ASIKUMA',
                    'BREMAN UGC',
                    'BUI',
                    'BUILSA COMMUNITY BANK LTD-SANDEMA',
                    'BUIPE',
                    'BUNKPRUGU',
                    'BURMA CAMP',
                    'BURMA CAMP BRANCH',
                    'BUSIE',
                    'BUSUNYA',
                    'BUTAWU RURAL BANK LTD-HO',
                    'BUWUULONSO RURAL BANK LTD-TAMALE',
                    'CAPE COAST',
                    'CAPE COAST BRANCH',
                    'CAPE COAST- MELCOM',
                    'CAPE COAST- MFANTSIPIM',
                    'CAPECOAST BRANCH',
                    'CAPITAL RURAL BANK LTD-ABESIM',
                    'CASTLE RD',
                    'CASTLE ROAD',
                    'CASTLE ROAD (HEAD OFFICE)',
                    'CASTLE ROAD BRANCH',
                    'CEDI HOUSE',
                    'CHAMBA',
                    'CHAPEL SQUARE',
                    'CHARIA',
                    'CHEREPONI',
                    'CHIRAA',
                    'CHORKOR',
                    'CIRCLE',
                    'CIRCLE BRANCH',
                    'CITIZEN RURAL BANK LTD-ACCRA',
                    'CLEARING UNIT',
                    'COLLINS AVENUE',
                    'COLLINS STREET',
                    'COMMUNITY 25',
                    'COMMUNITY 6',
                    'COMMUNITY1 BRANCH',
                    'CONSUMER FINANCE COMPANY (CFC) LTD',
                    'CORPORATE',
                    'CORPORATE SERVICE CENTRE',
                    'CUC MIOTSO',
                    'DA RURAL BANK LTD-KASSEH',
                    'DABALA',
                    'DABAN',
                    'DABOASE',
                    'DADIESO',
                    'DAMANG',
                    'DAMANGO',
                    'DAMBAI',
                    'DAMONGO',
                    'DANGBE RURAL BANK LTD-PRAMPRAM',
                    'DANICOM HOUSE(KOKOMLEMLE)',
                    'DANQUAH CIRCLE',
                    'DANSI RURAL BANK LTD-FOMENA',
                    'DANSOMAN',
                    'DANSOMAN EXHIBITION BRANCH',
                    'DANSOMAN ROUND-ABOUT BRANCH',
                    'DARKUMAN',
                    'DARKUMAN BRANCH',
                    'DAWA',
                    'DENKYIRAMAN RURAL BANK LTD-AYAMFURI',
                    'DENU',
                    'DERBY AVENUE',
                    'DERMA',
                    'DERMA RURAL BANK LTD-DERMA',
                    'DIRECT SALES',
                    'DODOWA',
                    'DOME',
                    'DOME BRANCH',
                    'DOME ST. JOHNS',
                    'DONKORKROM',
                    'DONTEN COMMUNITY BANK LTD-NEW TAFO',
                    'DORMAA AHENKRO',
                    'DOTOBRI RURAL BANK LTD-JACOBU',
                    'DROBO',
                    'DROBO COMMUNITY RURAL BANK LTD-DROBO',
                    'DRORWULU',
                    'DUADASO',
                    'DUAYAW NKANTA',
                    'DUAYAW NKWANTA',
                    'DUMPONG RURAL BANK LTD-OFRAMASE',
                    'DUNKWA',
                    'DUNKWA OFFIN',
                    'DUNKWA ON-OFFIN',
                    'DUNKWA-ON-OFFIN',
                    'DUNKWAW-ON-OFFIN BRANCH',
                    'DUPONGKPEHE RURAL BANK LTD-KASOA',
                    'DWEN-ANOMA RURAL BANK LTD-KWEEHWEE',
                    'DWORWULU WEST AIRPORT',
                    'DZEMENI',
                    'DZODZE',
                    'DZORWULU',
                    'DZORWULU BRANCH',
                    'DZORWULU MOTORWAY',
                    'DZWORWULU',
                    'EAST AIRPORT BRANCH',
                    'EAST CANTONMENT',
                    'EAST CANTONMENTS BRANCH',
                    'EAST LEGON',
                    'EAST LEGON 1',
                    'EAST LEGON 2',
                    'EAST LEGON BRANCH',
                    'EAST MANPRUSI COMMUNITY BABK LTD-GAMBAGA',
                    'EASTERN GOMOA ASSIN RURAL BANK LTD-GOMOA-DOMINASE',
                    'EBANKESE',
                    'ECOBANK BANTAMA GNTC',
                    'ECOBANK COMMUNITY 1',
                    'ECOBANK E PROCESS',
                    'ECOBANK EAST AIRPORT',
                    'ECOBANK EVANDY HOSTEL',
                    'ECOBANK GH TAMALE',
                    'ECOBANK GHANA',
                    'ECOBANK HIGH STREET',
                    'ECOBANK HOSPITAL ROAD',
                    'ECOBANK KANTAMANTO',
                    'ECOBANK MADINA CENTRAL',
                    'ECOBANK OKPONGLO',
                    'ECOBANK PENTAGON LEGON',
                    'ECOBANK SSNIT HOUSE',
                    'ECOBANK SUAME',
                    'EFFIDUASE',
                    'EFWIMAN RURAL BANK LTD-SEFWI-ASAW',
                    'EJISU',
                    'EJISU BRANCH',
                    'EJURA',
                    'EJURAMAN RURAL BANK LTD-KUMASI',
                    'EKUMFIMAN RURAL BANK LTD-ESSUEHYIA',
                    'EKYEDUMASI RURAL BANK LTD-SEKYEDUMASI',
                    'EKYERE RURAL BANK LTD-JAMASI',
                    'ELMINA',
                    'ELMINA - CHAPEL SQUARE',
                    'ELMINA -ESSUAKYIR',
                    'ELUBO',
                    'ELUBU',
                    'ENCHI',
                    'ENCHI BRANCH',
                    'ENCHI RURAL BANK LTD',
                    'ENKYIRAMAN RURAL BANK LTD-AYAMFURI',
                    'ENYAN DENKYIRA RURAL BANK LTD-ENYAN DENKYIRA',
                    'EPAMAN RURAL BANK LTD - TEPAMAN',
                    'EPE AREA RURAL BANK LTD-MEPE',
                    'ERMA RURAL BANK LTD-DERMA',
                    'ESIAMA',
                    'ESSAM',
                    'ESSFA RURAL BANK LTD-GARU',
                    'EST MANPRUSI COMMUNITY BANK LTD-WALEWALE',
                    'ESTERN RURAL BANK LTD-WASSA AKROPONG',
                    'ETO RURAL BANK LTD-KPEVE',
                    'EVANDY HOSTEL BRANCH',
                    'EZI SAVINGS AND LOANS LTD',
                    'FAANOFA',
                    'FAMAL',
                    'FANTEAKWA RURAL BANK LTD-KOFORIDUA',
                    'FANTSIMAN COMMUNITY RURAL BANK LTD-BIRIWA',
                    'FARRAR',
                    'FFINSO RURAL BANK LTD-KUMASI',
                    'FIAGYA RURAL BANK LTD-BUSUNYA',
                    'FIAPRE',
                    'FIASEMAN (BOGOSO AREA) RURAL BANK LTD-BOGOSO',
                    'FIRST AFRICAN SAVINGS AND LOANS',
                    'FIRST ALLIED SAVINGS & LOANS',
                    'FIRST ALLIED SAVINGS AND LOANS',
                    'FIRST GHANA BUILDING SOCIETY- ACCRA',
                    'FIRST GHANA BUILDING SOCIETY- KOFORIDUA',
                    'FIRST GHANA BUILDING SOCIETY- KUMASI AMAKOM',
                    'FIRST GHANA BUILDING SOCIETY- KUMASI SUAME',
                    'FIRST GHANA BUILDING SOCIETY- SUNYANI',
                    'FIRST GHANA BUILDING SOCIETY- TAKORADI',
                    'FIRST GHANA BUILDING SOCIETY-HEAD OFFICE',
                    'FIRST GHANA BUILDING SOCIETY-HOHOE',
                    'FIRST GHANA BUILDING SOCIETY-TAKORADI',
                    'FIRST GHANA BUILDING SOCIETY-TEMA',
                    'FIRST NATATIONAL S&L',
                    'FIRST NATIONAL SAVINGS & LOANS',
                    'FOASE',
                    'FOREIGN',
                    'FOREIGN OPERATIONS',
                    'FOREIGN OPERATIONS BRANCH',
                    'FRAM RURAL BANK LTD-TEASE',
                    'FULFOSO',
                    'FUMBISI',
                    'GA RURAL BANK LTD-AMASAMAN',
                    'GAMASHIE',
                    'GARU',
                    'GAVE RURAL BANK LTD-DABALE',
                    'GBI RURAL BANK LTD-HOHOE',
                    'GICEL',
                    'GIMPA',
                    'GIMPA BRANCH',
                    'GLOBAL ACCESS SAVINGS & LOANS CO. LTD',
                    'GNPC',
                    'GNPC TEMA',
                    'GOASO',
                    'GOLDEN TULIP KUMASI BRANCH',
                    'GOLOKWATI',
                    'GOMOA AJUMAKO RURAL BANK LTD-AFRANSI',
                    'GOMOA RURAL BANK LTD-APAM',
                    'GONA RURAL BANK LTD-KWANYAKU',
                    'GRAPHIC ROAD',
                    'GREL',
                    'GULF HOUSE',
                    'GUMANI',
                    'GUSHIEGU',
                    'GWB LAPAZ',
                    'HAATSO',
                    'HAATSOO',
                    'HAFO ANO PREMIER RURAL BANK LTD-WIOSO',
                    'HAFO COMMUNITY RURAL BANK LTD-KUKUOM',
                    'HAI RURAL BANK LTD-DODOWA',
                    'HALF ASSINI',
                    'HAMILE',
                    'HANTAMAN RURAL BANK LTD-AGONA NKWANTA',
                    'HAPER ROAD',
                    'HARBOUR AREA',
                    'HARPER ROAD',
                    'HARPER ROAD BRANCH',
                    'HE SEED SAVINGS AND LOANS',
                    'HEAD OFFICE',
                    'HEAD-OFFICE',
                    'HIGH STREET',
                    'HIGH STREET BRANCH',
                    'HIGH STREET TAKORADI',
                    'HIGH STREET-TAKORADI',
                    'HO',
                    'HO AGENCY',
                    'HO BRANCH',
                    'HO MARKET',
                    'HO POLYTECHNIC',
                    'HO POST',
                    'HO POSTBANK',
                    'HOEHOE',
                    'HOHOE',
                    'HOHOE POST',
                    'HOHOE POSTBANK',
                    'HOSPITAL ROAD BRANCH',
                    'HWEDIEM',
                    'HWIDIEM',
                    'HWIDIEM[ B/A]',
                    'IAGYA RURAL BANK LTD-BUSUNYA',
                    'IASEMAN (BOGOSO AREA) RURAL BANK LTD-BOGOSO',
                    'IA-TORYA RURAL BANK LTD-BONSU-NKWANTA',
                    'ICROFIN RURAL BANK LIMITED',
                    'INDEPENDENCE AVENUE',
                    'INDUSTRIAL AREA',
                    'INTAMPO RURAL BANK LTD-KINTAMPO',
                    'INTERNATIONAL BANKING',
                    'IPS',
                    'IPS BRANCH',
                    'IPS LEGON',
                    'IRST GHANA BUILDING SOCIETY- ACCRA',
                    'IRST GHANA BUILDING SOCIETY- KOFORIDUA',
                    'IRST GHANA BUILDING SOCIETY- KUMASI AMAKOM',
                    'IRST GHANA BUILDING SOCIETY- KUMASI SUAME',
                    'IRST GHANA BUILDING SOCIETY- SUNYANI',
                    'IRST GHANA BUILDING SOCIETY- TAKORADI',
                    'IRST GHANA BUILDING SOCIETY-HEAD OFFICE',
                    'IRST GHANA BUILDING SOCIETY-HOHOE',
                    'IRST GHANA BUILDING SOCIETY-TAKORADI',
                    'IRST GHANA BUILDING SOCIETY-TEMA',
                    'ISSALA RURAL BANK LTD-TUMA',
                    'ITIZEN RURAL BANK LTD-ACCRA',
                    'IZAA RURAL BANK LTD-TAMALE',
                    'JACOBU',
                    'JANYAGU',
                    'JAPEKROM',
                    'JAPEKROM/DROBO',
                    'JASIKAN',
                    'JEMA',
                    'JINIJIN',
                    'JIRAPA',
                    'JISONAYILI',
                    'JOMORO RURAL BANK LTD-TIKOBO NO. 1',
                    'JUABEN RURAL BANK LTD-JUABEN',
                    'JUABESO',
                    'JUAPONG',
                    'JUASO',
                    'JUBILEE HOUSE',
                    'JUBILEE HOUSE COCOBOD BUILDING',
                    'JUKWA',
                    'JUNCTION MALL',
                    'JUNCTION MALL BRANCH',
                    'JURAMAN RURAL BANK LTD-KUMASI',
                    'KAASE',
                    'KAASEMAN RURAL BANK LTD-KAASE',
                    'KADE',
                    'KADJEBI',
                    'KAJEBI',
                    'KAKUM RURAL BANK LTD-ELMINA',
                    'KALADAN',
                    'KANASHIE',
                    'KANESHIE',
                    'KANESHIE BRANCH',
                    'KANESHIE INDUSTRIAL AREA',
                    'KANESHIE MAIN',
                    'KANESHIE MARKET',
                    'KANESHIE POST OFFICE',
                    'KANESHIE POST OFFICE BRANCH',
                    'KANESSHIE',
                    'KANTAMANTO',
                    'KANTAMANTO AGENCY',
                    'KANTAMANTO BRANCH',
                    'KARAGA',
                    'KASAPIN',
                    'KASOA',
                    'KASOA BRANCH',
                    'KASOA MAIN',
                    'KASOA MAIN BRANCH',
                    'KASOA MARKET',
                    'KASOA MILLENIUM CITY',
                    'KASOA NEW MARKET',
                    'KATAKYIMAN RURAL BANK LTD-KOMENDA',
                    'KEJETIA',
                    'KEJETIA BRANCH',
                    'KEJETIA- KUMASI',
                    'KENYASE',
                    'KENYASI AGENCY',
                    'KETA',
                    'KETE KRACHI',
                    'KIBI',
                    'KIM BOSOME RURAL BANK LTD-AKIM SWEDRU',
                    'KINTAMPO',
                    'KINTAMPO RURAL BANK LTD-KINTAMPO',
                    'KISSEIMAN BRANCH',
                    'KISSI',
                    'KISSIEMAN',
                    'KNUST',
                    'KNUST BRANCH',
                    'KNUST CAMPUS',
                    'KNUST KUMASI',
                    'KNUTSFORD',
                    'KNUTSFORD AVENUE',
                    'KOFORIDUA',
                    'KOFORIDUA BRANCH',
                    'KOFORIDUA KAMA CENTRE',
                    'KOJO THOMPSON ROAD',
                    'KOKOMLEMLE BRANCH',
                    'KOMENDA',
                    'KOMFO ANOKYE RURAL BANK LTD-WIAMOASE',
                    'KOMLEMLE',
                    'KONGO',
                    'KONONGO',
                    'KORANMAN RURAL BANK LTD-SEIKWA',
                    'KORANZA KWABRE RURAL BANK LTD-AKUMA',
                    'KORKORDZOR',
                    'KORLE BU',
                    'KORLE DUDOR',
                    'KORLE DUDOR BRANCH',
                    'KORLE-BU',
                    'KORLE-BU BRANCH',
                    'KOTI RURAL BANK LTD-ASSIN AKROPONG',
                    'KOTOBABI',
                    'KPADIE',
                    'KPANDAI',
                    'KPANDO',
                    'KPANDU',
                    'KPASSA RURAL BANK LTD-HOHOE',
                    'KPEDZE',
                    'KPETOE',
                    'KPEVE',
                    'KPONE',
                    'KPONG',
                    'KRACHE NKWANTA',
                    'KRANKWANTA RURAL BANK LTD-SUNYANI',
                    'KROFOM',
                    'KROFROM',
                    'KROFUOM AREA RURAL BANK LTD-AKROFUOM',
                    'KRONUM BRANCH',
                    'KUAPEM RURAL BANK LTD-MAMFE',
                    'KUMASI',
                    'KUMASI (ALABAR)',
                    'KUMASI ADUM',
                    'KUMASI -ADUM',
                    'KUMASI AMAKOM',
                    'KUMASI ASAFO',
                    'KUMASI ASAFO BRANCH',
                    'KUMASI ASOKWA',
                    'KUMASI BRANCH',
                    'KUMASI CENT.',
                    'KUMASI CENTRAL',
                    'KUMASI CENTRAL MARKET',
                    'KUMASI HARPER ROAD',
                    'KUMASI MAIN',
                    'KUMASI PREMPEH 11 STREET',
                    'KUMASI PREMPEH STREET',
                    'KUMASI SUAME',
                    'KUMASI TANNOSO',
                    'KUMASI-LAKE  ROAD',
                    'KUMAWUMAN RURAL BANK LTD-KUMAWU',
                    'KUMFIMAN RURAL BANK LTD-ESSUEHYIA',
                    'KWABENYA',
                    'KWABENYA BRANCH',
                    'KWADASO',
                    'KWAEBIBIREM RURAL BANK LTD-ASUOM',
                    'KWAHU PRASO RURAL BANK LTD-KWAHU PRASO',
                    'KWAHU RURAL BANK LTD-KWAHU PEPEASE',
                    'KWAHUTAFO',
                    'KWAMANMAN RURAL BANK LTD-KWAMANG',
                    'KWAME DANSO BRANCH',
                    'KWAME NKRUMAH AVE',
                    'KWAME NKRUMAH CIRCLE',
                    'KWAPONG',
                    'KWASHIEMAN',
                    'KWASHIEMAN BRANCH',
                    'KYEKYEWERE',
                    'KYEM MANSA RURAL BANK LTD-AYIREBI',
                    'KYEPIM RURAL BANK LTD-GOMOA-DAW',
                    'LA',
                    'LA COMMUNITY BANK LTD-LA',
                    'LABONE',
                    'LABONE BRANCH',
                    'LAPAZ',
                    'LAPAZ BRANCH',
                    'LASHIBI',
                    'LASHIBI BRANCH',
                    'LAW COURT COMPLEX',
                    'LAW-COURT',
                    'LAWRA',
                    'LAWRA RURAL BANK LTD-WA',
                    'LEGON',
                    'LEGON MAIN',
                    'LIBERATION ROAD TAKORADI',
                    'LIBERATION ROAD TOKORADI',
                    'LIBERATION ROAD-TAKORADI',
                    'LIBERIA ROAD',
                    'LIBERTY HSE',
                    'LOTTERIES',
                    'LOWER PRA RURAL BANK LTD-SHAMA',
                    'MAAKRO BRANCH',
                    'MAAME KROBO',
                    'MAAMOBI',
                    'MACCARTHY HILL',
                    'MADINA',
                    'MADINA BRANCH',
                    'MADINA CENTRAL BRANCH',
                    'MADINA MAIN BRANCH',
                    'MADINA NEW ROAD BRANCH',
                    'MAKANGO',
                    'MAKOLA',
                    'MAKOLA BRANCH',
                    'MAKOLA SQUARE',
                    'MALLAM',
                    'MALLAM INTERCHANGE',
                    'MALLAM JUNCTION BRANCH',
                    'MAMFE AKUAPIM',
                    'MAMFE BRANCH',
                    'MAMOBI',
                    'MAMOBI BRANCH',
                    'MAMPONG',
                    'MAMPONG AKWAPIM',
                    'MAMPONG ASHANTI',
                    'MAMPROBI',
                    'MAMPROBI POST',
                    'MAMPROBI POSTBANK',
                    'MANANO RURAL BANK LTD-NYINAHIM',
                    'MANET TOWER 3 BRANCH',
                    'MANKESSIM',
                    'MANKESSIM OFFICE COMPLEX',
                    'MANKRASO',
                    'MANSO NKWANTA',
                    'MANSOMAN RURAL BANK LTD-MANSO-AMENFI',
                    'MANYA KROBO RURAL BANK LTD-ODUMASE-KROBO',
                    'MARKET CIRCLE BRANCH',
                    'MARKET CIRCLE TAKORADI',
                    'MASIE WEST RURAL BANK LTD-ANTOAKROM',
                    'MATAHEKO',
                    'MATIN AND KASEI COMMUNITY BANK LTD-KASEI',
                    'MAX MART',
                    'MCCARTHY HILL',
                    'MELCOM',
                    'MENFIMAN RURAL BANK LTD-WASSA AKROPONG',
                    'MEPE AREA RURAL BANK LTD-MEPE',
                    'MERIDIAN BRANCH',
                    'MFANTSIMAN COMMUNITY RURAL BANK LTD-BIRIWA',
                    'MFANTSIPIM',
                    'MICHEL CAMP',
                    'MICROFIN RURAL BANK LIMITED',
                    'MIDLAND SAVING AND LOANS',
                    'MIDLAND SAVINGS & LOANS LTD',
                    'MILE 7/TANTRA',
                    'MIM',
                    'MINISTRIES',
                    'MIOTSO',
                    'MOREE',
                    'MOTOR WAY ROUNDABOUT',
                    'MOTORWAY EXT',
                    'MOTORWAY EXTENSION',
                    'MOTORWAY ROUNDABOUT',
                    'MPATASIE',
                    'MPOHOR',
                    'MPONUA RURAL BANK LTD-AMUANA PRASO',
                    'MPRAESO',
                    'MULTI CREDIT SAVINGS AND LOANS - KUMASI',
                    'MULTICREDIT SAVINGS AND LOANS CO.',
                    'MUMFORD',
                    'MUMUADA RURAL BANK LTD-OSINO',
                    'NAARA RURAL BANK LTD-PAGA',
                    'NAFANA RURAL BANK LTD-SAMPA',
                    'NAGODE',
                    'NANDOM',
                    'NANDOM RURAL BANK LTD-NANDOM',
                    'NAVORONGO',
                    'NAVRONGO',
                    'NBFI-ADVANS GH',
                    'NCHIRAA',
                    'NCR',
                    'NEW ABEKA',
                    'NEW ABIREM',
                    'NEW ABIREM BRANCH',
                    'NEW ABRIEM',
                    'NEW ADUBIASE',
                    'NEW AMAKOM',
                    'NEW DORMAA KOTOKROM',
                    'NEW EDUBIASE',
                    'NEW NINGO',
                    'NEW OFFINSO',
                    'NEW SUAME MAGAZINE',
                    'NEW TAFO',
                    'NEW TOWN',
                    'NEWTOWN',
                    'NEWTOWN ACCRA',
                    'NHYIAESO BRANCH',
                    'NHYIEASO',
                    'NHYIESO',
                    'NIA',
                    'NIA BRANCH',
                    'NIMA',
                    'NIMA BRANCH',
                    'NIMA MAIN BRANCH',
                    'NINGO',
                    'NION RURAL BANK LTD-SENYA BREKU',
                    'NITY RURAL BANK LTD-ZIOPE',
                    'NKAWIE',
                    'NKAWKAW',
                    'NKOBRA WEST (ESIAMA) RURAL BANK LTD-ESIAMA',
                    'NKORANMAN RURAL BANK LTD-SEIKWA',
                    'NKORANSAH',
                    'NKORANZA',
                    'NKORANZA KWABRE RURAL BANK LTD-AKUMA',
                    'NKRANKWANTA',
                    'NKRANKWANTA RURAL BANK LTD-SUNYANI',
                    'NKWAKAW POST',
                    'NKWANTA',
                    'NLO RURAL BANK LTD-ANLOGA',
                    'NOBLE DREAM MICROFINANCE LTD',
                    'NORTH INDUSTRIAL',
                    'NORTH INDUSTRIAL AREA',
                    'NORTH INDUSTRIAL AREA BRANCH',
                    'NORTH KANESHIE',
                    'NORTH RIDGE',
                    'NORTH TONGU RURAL BANK LTD-ADIDOME',
                    'NORTH VOLTA RURAL BANK LTD-GUAMAN',
                    'NSAWAM',
                    'NSOATREMAN RURAL BANK LTD-NSOATRE',
                    'NSUATRE',
                    'NSUFA ASHANTI',
                    'NSUTAMAN RURAL BANK LTD-NSUTA',
                    'NTOROSO',
                    'NUM RURAL BANK LTD-ANUM',
                    'NUNGUA',
                    'NWABIAGYA RURAL BANK LTD-BAREKESE',
                    'NYAKROM RURAL BANK LTD-NYAKROM',
                    'NYAN DENKYIRA RURAL BANK LTD-ENYAN DENKYIRA',
                    'NYANKPALA',
                    'NYANKUMASE AHENKRO RURAL BANK LTD-FANTI NYANKUMASE',
                    'NYIAESO',
                    'NYIAESO AHODWO',
                    'NZEMA MANLE RURAL BANK LTD-AWIEBO',
                    'OBUASI',
                    'ODA',
                    'ODA NKWANTA',
                    'ODORKOR',
                    'ODOTOBRI RURAL BANK LTD-JACOBU',
                    'ODUPONGKPEHE RURAL BANK LTD-KASOA',
                    'ODWEN-ANOMA RURAL BANK LTD-KWEEHWEE',
                    'OENDE RURAL BANK LTD-ZIBILLA',
                    'OFFINSO',
                    'OFFINSO RURAL BANK LTD-KUMASI',
                    'OFFSHORE BANKING',
                    'OFFSHORE BANKING UNIT - GH',
                    'OKAISHIE',
                    'OKAISHIE BRANCH',
                    'OKOFO BRANCH',
                    'OKOMFO ANOKYE RURAL BANK LTD-WIAMOASE',
                    'OKPONGLO',
                    'OKPONGLO BRANCH',
                    'OLA',
                    'OLD NINGO',
                    'OLD SUAME MAGAZINE',
                    'OLD TAFO',
                    'OMAA AREA RURAL BANK LTD-BOMAA',
                    'OMOA AJUMAKO RURAL BANK LTD-AFRANSI',
                    'OMOA RURAL BANK LTD-APAM',
                    'OMORO RURAL BANK LTD-TIKOBO NO. 1',
                    'OMOSADU RURAL BANK LTD',
                    'ONGO RURAL BANK LTD-BOLGATANGA',
                    'ONZALI RURAL BANK LTD-KUMBUNGU',
                    'ONZELE RURAL BANK LTD-JIRAPA',
                    'OPEIBEA HOUSE',
                    'OPERA SQUARE',
                    'OPERA SQUARE BRANCH',
                    'OPPORTUNITY INT. SAVINGS AND LOAN',
                    'OPPORTUNITY INT. SAVINGS AND LOANS',
                    'OPPORTUNITY INTERNATIONAL',
                    'OREIGN',
                    'ORIMANGA RURAL BANK LTD-SAVELEGU',
                    'ORTH TONGU RURAL BANK LTD-ADIDOME',
                    'ORTH VOLTA RURAL BANK LTD-GUAMAN',
                    'OSEI KWADWO KROM',
                    'OSOME FREHO RURAL BANK LTD-KUMASI',
                    'OSOMTWI RURAL BANK LTD-KUNTANASE',
                    'OSU',
                    'OSU  OXFORD BRANCH',
                    'OSU - OXFORD STREET',
                    'OSU - WATSON STREET',
                    'OSU OXFORD ST.',
                    'OSU OXFORD STREET',
                    'OSU WATSON BRANCH',
                    'OTUASEKAN RURAL BANK LTD-KOFIASE',
                    'OUTH AKIM RURAL BANK LTD-NANKESE',
                    'OUTH BIRIM RURAL BANK LTD-ACHIASE',
                    'OWER PRA RURAL BANK LTD-SHAMA',
                    'OXFORD STREET BRANCH',
                    'OYIBI AREA RURAL BANK LIMITED',
                    'PACIFIC SAVINGS AND LOANS LTD',
                    'PAGA',
                    'PALM WINE JUNCTION',
                    'PALMWINE JUNCTION',
                    'PARLIAMENT HOUSE',
                    'PASSA RURAL BANK LTD-HOHOE',
                    'PATASE',
                    'PATRICE LUMUMBA ROAD',
                    'PEKI',
                    'PENTAGON LEGON BRANCH',
                    'PEX BANK - BOLGA CENTRE-BOLGATANGA',
                    'PEX BANK - CAPE COASTCAPE COAST',
                    'PEX BANK - TAMALE CENTRE-TAMALE',
                    'PEX BANK -HEAD OFFICE-SOUTH RIDGE ACCRA',
                    'PEX BANK -HOHOE CENTRE-HOHOE',
                    'PEX BANK KOFORIDUA CENTRE-KOFORIDUA',
                    'PEX BANK -SUNYANI CENTRE-SUNYANI',
                    'PEX BANK -WA CENTRE-WA',
                    'PEX BANKACCRA CENTRE-ACCRA',
                    'PEX BANK-HO CENTRE-HO',
                    'PEX BANK-KUMASIKUMASI',
                    'PEX BANK-TAKORADI CENTRE-TAKORADI',
                    'PEX LINK CENTRE-CEDI HOUSE',
                    'PIG FARM BRANCH',
                    'POKUASE',
                    'POKUASE BRANCH',
                    'PONUA RURAL BANK LTD-AMUANA PRASO',
                    'POST OFFICE SQUARE',
                    'POTSIN',
                    'PPER AMENFI RURAL BANK LTD-ANKWAWSO',
                    'PPER MANYA KRO RURAL BANK LTD-ASESEWA',
                    'PRAMPRAM',
                    'PRANG',
                    'PREMIER TOWERS',
                    'PREMPEH II STREET',
                    'PRESTEA',
                    'PRIVATE BANKING',
                    'PROCREDIT SAVINGS & LOANS',
                    'PUSIGA',
                    'RAKWA BRAMAN RURAL BANK LTD-BRAKWA',
                    'REINSURANCE HOUSE',
                    'REINSURANCE HOUSE BRANCH',
                    'REPUBLIC HOUSE',
                    'RIDGE',
                    'RIDGE BRANCH',
                    'RIDGE TOWERS',
                    'RING ROAD',
                    'RING ROAD BRANCH',
                    'RING ROAD CENTRAL',
                    'RING ROAD CENTRAL BRANCH',
                    'RING ROAD WEST',
                    'ROBO COMMUNITY RURAL BANK LTD-DROBO',
                    'ROMAN HILL',
                    'ROMAN HILL BRANCH',
                    'ROMAN HILL MARKET BRANCH',
                    'RRC',
                    'RRC REMITTANCE CENTRE',
                    'RUSSIA ROAD BRANCH',
                    'SABOBA',
                    'SAFE BOND',
                    'SAFE BOND JUBILEE',
                    'SAFE BOUND JUBILEE',
                    'SAFEBOND',
                    'SAKAMAN',
                    'SAKUMONO',
                    'SAKUMONO BRANCH',
                    'SALAGA',
                    'SALTPOND',
                    'SAMPA',
                    'SAMREBOI',
                    'SANDEMA',
                    'SANKORE',
                    'SANTA MARIA',
                    'SANTASI',
                    'SANTE AKYEM RURAL BANK LTD-JUANSA',
                    'SAVELUGU',
                    'SAWINSO RURAL BANK LTD-SEFWI-ASAWINSO',
                    'SAWLA',
                    'SEFWI BEKWAI',
                    'SEFWI BRANCH',
                    'SEFWI ESSAM',
                    'SEFWI WIAWO',
                    'SEFWI WIAWSO',
                    'SEFWIMAN RURAL BANK LTD-SEFWI-ASAW',
                    'SEFWI-WIASO',
                    'SEGE',
                    'SEKONDI',
                    'SEKYEDUMASI RURAL BANK LTD-SEKYEDUMASI',
                    'SEKYERE RURAL BANK LTD-JAMASI',
                    'SERVICE BRANCH',
                    'SHAI RURAL BANK LTD-DODOWA',
                    'SHIPPERS HOUSE BRANCH',
                    'SILVER STAR',
                    'SINAPI ABA SAVINGS & LOAN',
                    'SINAPI ABA SAVINGS & LOANS',
                    'SISSALA RURAL BANK LTD-TUMA',
                    'SME',
                    'SME CENTRE',
                    'SOATREMAN RURAL BANK LTD-NSOATRE',
                    'SOGAKOPE',
                    'SOKOBAN',
                    'SOKOBAN BRANCH',
                    'SOKORE RURAL BANK LTD-ASOKRE',
                    'SOMANYA',
                    'SONZELE RURAL BANK LTD-JIRAPA',
                    'SOUTH AKIM RURAL BANK LTD-NANKESE',
                    'SOUTH BIRIM RURAL BANK LTD-ACHIASE',
                    'SOUTH INDUSTRIAL AREA',
                    'SOUTH INDUSTRIAL AREA(SIA)',
                    'SOUTH INDUSTRIAL BRANCH',
                    'SOUTH LEGON BRANCH',
                    'SOWUTUOM',
                    'SPINTEX',
                    'SPINTEX BRANCH',
                    'SPINTEX MAIN',
                    'SPINTEX PRESTIGE',
                    'SPINTEX ROAD',
                    'SPINTEX ROAD BRANCH',
                    'SSINMAN RURAL BANK LTD-ASSIN MANSO',
                    'SSNIT HOUSE BRANCH',
                    'ST PETERS CO-OPERATIVE CREDIT UNION',
                    'STADIUM',
                    'STADIUM AMAKOM',
                    'STADIUM POST',
                    'STEWART AVENUE KUMASI',
                    'SUAME',
                    'SUAME BRANCH',
                    'SUAME MAAKRO',
                    'SUBONTEN RURAL BANK LTD-WORAWORA',
                    'SUHUM',
                    'SUHUM RURAL BANK',
                    'SUMA RURAL BANK LTD-SUMA AHENKRO',
                    'SUNYANI',
                    'SUNYANI CENTRAL',
                    'SUNYANI MAIN BRANCH',
                    'SUNYANI NIMPONG',
                    'SUNYANI ODUMASE',
                    'SUNYANI POST OFFICE BRANCH',
                    'SUNYANI POSTBANK',
                    'SUOGYAMAN RURAL BANK LTD-ACCRA',
                    'SUOPRA RURAL BANK LTD-AFOSU',
                    'SUTAMAN RURAL BANK LTD-NSUTA',
                    'SUTIFI RURAL BANK LTD-ACERENSUA',
                    'SWANMILL',
                    'SWEDRU',
                    'SWEDRU BRANCH',
                    'TAFO',
                    'TAFO BRANCH',
                    'TAIFA',
                    'TAKORADI',
                    'TAKORADI - KOKOMPE',
                    'TAKORADI BRANCH',
                    'TAKORADI EFFIEKUMA',
                    'TAKORADI HABOUR BRANCH',
                    'TAKORADI HARBOUR',
                    'TAKORADI HARBOUR ROAD',
                    'TAKORADI KOKOMPE',
                    'TAKORADI MAIN',
                    'TAKORADI MARKET CIRCLE',
                    'TAKORADI MKT CIRCLE',
                    'TAKORADI POST',
                    'TAKORADI POSTBANK',
                    'TAMALE',
                    'TAMALE ABOABO',
                    'TAMALE ABOABO BRANCH',
                    'TAMALE BRANCH',
                    'TAMALE CENTRAL',
                    'TAMALE HOSP ROAD',
                    'TAMALE HOSPITAL ROAD',
                    'TAMALE HOSPITAL ROAD BRANCH',
                    'TAMALE LAMESHEGU',
                    'TAMALE MAIN BRANCH',
                    'TAMALE MARKET',
                    'TANOKROM',
                    'TANOSO',
                    'TANTRA',
                    'TARKORADI MARKET',
                    'TARKWA',
                    'TARKWA BRANCH',
                    'TARKWA MINES',
                    'TEASE',
                    'TECH JUNCTION',
                    'TECHIMAN',
                    'TECHIMAN BRANCH',
                    'TECHIMAN MARKET',
                    'TECHIMAN MARKET BRANCH',
                    'TECHIMAN NORTH BRANCH',
                    'TECHIMAN TIA BRANCH',
                    'TECHIMAN VALLEY VIEW BRANCH',
                    'TECHIMAN WENCHI ROAD BRANCH',
                    'TEMA',
                    'TEMA BRANCH',
                    'TEMA COMM 1',
                    'TEMA COMM 2',
                    'TEMA COMM 4',
                    'TEMA COMM. 25',
                    'TEMA COMM. 6',
                    'TEMA COMMUNITY 1',
                    'TEMA COMMUNITY 1 BRANCH',
                    'TEMA COMMUNITY 2 BRANCH',
                    'TEMA COMMUNITY 25',
                    'TEMA COMMUNITY 25 BRANCH',
                    'TEMA COMMUNITY 6',
                    'TEMA COMMUNITY 9',
                    'TEMA COMMUNITY ONE',
                    'TEMA COMMUNITY TWO',
                    'TEMA DRYDOCK',
                    'TEMA EAST',
                    'TEMA FISHING HABOUR',
                    'TEMA FISHING HARBOUR',
                    'TEMA HABOUR',
                    'TEMA HARBOUR',
                    'TEMA INDUSTRIAL AREA',
                    'TEMA LONG ROOM',
                    'TEMA MAIN',
                    'TEMA MAIN BRANCH',
                    'TEMA MARKET',
                    'TEMA METRO BRANCH',
                    'TEMA OIL REFINERY',
                    'TEMA SAFEBOND',
                    'TEMA SHOPPING MAIL',
                    'TEMA SHOPPING MALL',
                    'TEMPANE BRANCH',
                    'TEPA',
                    'TEPAMAN RURAL BANK LTD - TEPAMAN',
                    'TESANO',
                    'TESANO BRANCH',
                    'TESHIE',
                    'TESHIE BRANCH',
                    'TESHIE NUNGUA',
                    'TETTEH QUARSHIE',
                    'THE SEED SAVINGS AND LOANS',
                    'TIA BRANCH',
                    'TIWA RURAL BANK LTD-KWABENG',
                    'TIZAA RURAL BANK LTD-TAMALE',
                    'TOENDE RURAL BANK LTD-ZIBILLA',
                    'TOLON',
                    'TONGU',
                    'TOR',
                    'TRADE FAIR',
                    'TRADE FAIR BRANCH',
                    'TREASURY',
                    'TREDE',
                    'TRUST TOWERS',
                    'TRUST TOWERS BRANCH',
                    'TSITO',
                    'TSOPOLI',
                    'TSUI BLEOO',
                    'TUASEKAN RURAL BANK LTD-KOFIASE',
                    'TUDU',
                    'TUDU BRANCH',
                    'TUMJU',
                    'TUMU',
                    'TUOBODOM',
                    'TUTU BRANCH',
                    'TWEABAN RURAL BANK LTD-SUNYANI',
                    'TWIFO PRASO',
                    'TWIFO RURAL BANK LTD-TWIFO AGONA',
                    'TWIMA KWANWOMA RURAL BANK LTD-PAKYI NO. 2',
                    'TWIMA MPONUA RURAL BANK LTD-TOASE',
                    'TWIMA RURAL BANK LTD-FOASE',
                    'UABEN RURAL BANK LTD-JUABEN',
                    'UCC',
                    'UEW BRANCH',
                    'UHUM RURAL BANK',
                    'UILSA COMMUNITY BANK LTD-SANDEMA',
                    'UMA RURAL BANK LTD-SUMA AHENKRO',
                    'UMAWUMAN RURAL BANK LTD-KUMAWU',
                    'UMPONG RURAL BANK LTD-OFRAMASE',
                    'UMUADA RURAL BANK LTD-OSINO',
                    'UNDP',
                    'UNION RURAL BANK LTD-SENYA BREKU',
                    'UNION SAVINGS & LOANS',
                    'UNION SAVINGS AND LOANS',
                    'UNION SAVINGS AND LOANS LIMITED',
                    'UNITY RURAL BANK LTD-ZIOPE',
                    'UNIV. OF CAPE COAST BRANCH',
                    'UNIVERSITY OF CAPE COAST',
                    'UNIVERSITY OF CAPE COAST BRANCH',
                    'UNIVERSITY OF GHANA BRANCH',
                    'UPPER AMENFI RURAL BANK LTD-ANKWAWSO',
                    'UPPER MANYA KRO RURAL BANK LTD-ASESEWA',
                    'UTAWU RURAL BANK LTD-HO',
                    'UTRAK SAVINGS AND LOANS',
                    'UWUULONSO RURAL BANK LTD-TAMALE',
                    'VAKPO',
                    'VALLEY VIEW',
                    'VALLEY VIEW UNIVERSITY- TECHIMAN',
                    'VENOR RURAL BANK LTD-AKATSI',
                    'WA',
                    'WA BRANCH',
                    'WABIAGYA RURAL BANK LTD-BAREKESE',
                    'WAEBIBIREM RURAL BANK LTD-ASUOM',
                    'WAHU PRASO RURAL BANK LTD-KWAHU PRASO',
                    'WAHU RURAL BANK LTD-KWAHU PEPEASE',
                    'WALEWALE',
                    'WAMANMAN RURAL BANK LTD-KWAMANG',
                    'WAMFIE',
                    'WAMFIE RURAL BANK LTD-WAMFIE',
                    'WASSA MANSO',
                    'WECHIAU',
                    'WEIJA',
                    'WEIJA BRANCH',
                    'WENCHI',
                    'WENCHI RURAL BANK LTD',
                    'WEST HILLS MALL',
                    'WEST LANDS',
                    'WEST MANPRUSI COMMUNITY BANK LTD-WALEWALE',
                    'WESTERN HILL',
                    'WESTERN RURAL BANK LTD-WASSA AKROPONG',
                    'WESTLANDS',
                    'WETO RURAL BANK LTD-KPEVE',
                    'WIDANA',
                    'WIFO RURAL BANK LTD-TWIFO AGONA',
                    'WINNEBA',
                    'WINNEBA BRANCH',
                    'WINNEBA RD',
                    'WINNEBA ROAD',
                    'WISCONSIN',
                    'WISCONSIN BRANCH',
                    'WOMANS WORLD BANKING',
                    'WOMENS WORLD BANK GHANA SAVINGS AND LOANS',
                    'WOMENS WORLD BANKING',
                    'WULENSI',
                    'WURIYENGA',
                    'WUTU EMASA RURAL BANK LTD-AWUMASA',
                    'YAA ASANTEWAA RURAL BANK LTD',
                    'YAKROM RURAL BANK LTD-NYAKROM',
                    'YANKUMASE AHENKRO RURAL BANK LTD-FANTI NYANKUMASE',
                    'YAPRA RURAL BANK LTD-PRANG',
                    'YEJI',
                    'YENDI',
                    'YESU NKWA',
                    'YIBI AREA RURAL BANK LIMITED',
                    'YUNYOO',
                    'ZABZUGU RURAL BANK LTD',
                    'ZEBILLA',
                    'ZEMA MANLE RURAL BANK LTD-AWIEBO',
                    'ZENITH BANK (GH) LTD-SUNYANI',
                    'ZENU',
                    'ZENU BRANCH',
                    'ZONGO JUNCTION',
                  ],
                },
                {
                  id: 'account-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Account Number',
                  uid: '495c881bcf57de23',
                  content: '',
                  publishChange: true,
                  errors: ['*', '*', '*'],
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas Html',
              uid: 'b25a984636d42a56',
              content:
                '<p><h2>Sign in the area below</h2></p>\n<p><p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p></p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
              markers: [],
              errors: ['*'],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '94903f65f4896769',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'b6a0fbc88aef4a50',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '7c7b941288238d47',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Payment Details',
    uri: 'lifetime-needs-plus/quote',
    class: 'life-time-needs-payment-details',
  },
  'stop-order-details': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: 'f60e03aa783ad770',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2 id="payment-details">Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '373c5662bc08cf41',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#additional">Additional</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="done clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'stop-order-details',
          type: 'list',
          readonly: false,
          label: 'Stop Order Details',
          uid: '9507e4585fe783c4',
          content: [
            {
              id: 'employer-organisation',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Employer Organisation',
              uid: '0822aa9611b07e14',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Employer Organisation',
              options: [
                '',
                'Abokobi Area Rural Bank Staff',
                'Accra Metro Assembly',
                'Advent Press',
                'African Regent Hotel',
                'Agave Rural Bank',
                'Agric Development Bank',
                'Ahafo Ano Premier Rural Bank',
                'Akaa Security Services',
                'Akwapem Rural Bank',
                'Aluworks',
                'Ama Dansowaa Clinic',
                'Amanano Rural Bank',
                'Amansie West Rural Bank',
                'Antrak Ghana Ltd',
                'Anum Rural Bank Ltd',
                'Apex Bank',
                'Ashante Akyem Rural Bank',
                'Asokore Rural Bank Ltd - Kumasi',
                'Asutifi Rural Bank Limited',
                'Atlantic Int. Holding Co',
                'Atwima Kwanwoma Rural Bank',
                'Atwima Rural Bank',
                'Auto Parts Limited',
                'Awutu Emasa Rural Bank',
                'Ayrton Drug Manufacturing Limited',
                'Bank Of Ghana',
                'Baptist Medical Centre',
                'Bible Society Of Ghana',
                'Bonzali Rural Bank',
                'Bosomtwe Rb',
                'Bureau Of National Investigations',
                'Capital Rural Bank',
                'Cejose Wisdom Int. School',
                'Ceps',
                'Chemico Limited',
                'Chirano Gold Mines',
                'Christ Ebenezer',
                'Christian Service University College - K',
                'Church Hill Of God',
                'Cocoa Marketiing Company Ltd',
                'Cocoa Processing Comp',
                'Controller',
                'Cssvd Control Unit',
                'Dangme Rural Bank Ltd - Staff',
                'De Youngsters International School Ltd',
                'Deoke Foundation Schools',
                'Derma Area Rural Bank',
                'Dizengoff Ghana Ltd',
                'Dynamic Insurance Brokers',
                'Ebennezer Osei Brenya Enterprise',
                'Ejuraman Rural Bank',
                'Englebert School',
                'Enterprise Funeral Services',
                'Enterprise Group Ltd',
                'Enterprise Insurance',
                'Enterprise Life Reps',
                'Enterprise Life Staff',
                'Enterprise Properties Ltd',
                'Enterprise Trustees Limited',
                'Epa',
                'Eskay Therapeutics Ltd',
                'Expandable Polystyrene Products Ltd',
                'Fiagya Rural Bank Ltd',
                'Fiesta Royale Hotel',
                'Forces Pay Office',
                'Ga East Municipal Assembly',
                'Ga Rural Bank',
                'Gafco',
                'Garden City Savings & Loans Limited',
                'Gcb Bank Ltd Staff',
                'Ghacem',
                'Ghana Airport Company Ltd.',
                'Ghana Cement',
                'Ghana Chamber Of Mines',
                'Ghana Civil Aviation Authority',
                'Ghana Cocoa Board',
                'Ghana Grid Company',
                'Ghana Heavy Equipment Limited',
                'Ghana Link Network Services Ltd',
                'Ghana Maritime Authority',
                'Ghana Medical School',
                'Ghana Oil Co. Ltd',
                'Ghana Police Service',
                'Ghana Post',
                'Ghana Railway Co. Ltd',
                'Ghana Re Company Limited',
                'Ghana Standard Board',
                'Ghana Union Conference Of S.D.A.',
                'Ghana Water Company Ltd',
                'Gihoc Distilleries Company Limited',
                'Gimpa',
                'Golden Exotics Ltd',
                'Goldengate Services Ltd',
                'Grace Baptist School - Kumasi',
                'Guiness Ghana Ltd',
                'Gwcl - Accra East',
                'Gwcl - Accra West',
                'Gwcl - Ashanti North',
                'Gwcl - Ashanti Production',
                'Gwcl - Ashanti South',
                'Gwcl - Head Office',
                'Gwcl - Sunyani',
                'Gwcl - Takoradi',
                'Gwcl - Tema',
                'Gwcl Greater Accra Region Production',
                'Hobats Clinic',
                'Holiday Inn Accra',
                'Home Finance Company Bank Ltd',
                'House Of Compassion Ministries',
                'Internal Revenue Service',
                'Japan Motors Trading Company',
                'Juaben Rural Bank',
                'Jubilee Shipping Services Gh Ltd',
                'K.N.U.S.T',
                'Kaaseman Rural Bank Ltd',
                'Kessben',
                'Kingsgroup Of Companies',
                'Kintampo Health Research Centre',
                'Korle Bu Teaching Hospital',
                'Krane Contsruction Co. Ltd',
                'Krobo Danish Association',
                'Kuapa Kokoo',
                'Kumawuman Rural Bank',
                'Kumawuman Rural Bnk',
                'Kwamaman Rural Bank',
                'Labadi Beach Hotel',
                'La Nkwantanang Madina Municipal Assembly',
                'Living Star School',
                'Lordship Insurance Brokers',
                'Lower Pra',
                'Maxam Ghana Ltd',
                'Mechanical Lloyd',
                'Metromass',
                'Mobitel',
                'Mondial Veneer Gh. Ltd',
                'Mumuada Rural Bank',
                'Nafana Rural Bank Ltd',
                'National Security',
                'Nexans',
                'Nsoatreman Rural Bank',
                'Nthc Properties Ltd',
                'Nwabiagya Rural Bank',
                'Okomfo Anokye Rural Bank Staff',
                'Opportunity International S.A Savings An',
                'Parliament',
                'Pbc Ltd',
                'Pentecost University College',
                'Phyto Riker',
                'Poly Products',
                "Presbyterian Women's Center - Abokobi",
                'Prince Of Peace',
                'Quality Control Division',
                'Quality Control Division (Cocobod)',
                'Regional Maritime Academy',
                'Ridge Church School',
                'Safebound Company Limited - Tema',
                'Sakworg Company Ltd',
                'Samartex Timber And Plywood Company',
                'Sandvik Mining And Construction Limited',
                'Scanbech Ghana Ltd',
                'Sdv Ghana',
                'Securities Discount Company Limited',
                'Sekyedumase Rural Bank',
                'Sekyere Rural Bank',
                'Sgs Laboratory Services',
                'Sg Ssb',
                'Silver Star Auto Ltd',
                'Sinapi Aba Trust',
                'Sofaamy Company Limited',
                "Sos Children's Village, Ghana",
                'South Birim Rural Bank',
                'Special Ice Company Ltd',
                'Ssnit',
                'St Ambrose College',
                "St Michael's Hospital, Pramso",
                'Stellar Logistic',
                'Sunyani Cluster Icps',
                'Takoradi Flour Mill Ltd',
                'Takoradi Int. Co.',
                'Tct',
                'Tema Development Corp.',
                'Tema Parents Association School',
                'Tesano Baptist Church',
                'The Church Of Pentecost',
                'Toende Rural Bank',
                'Trasacco',
                'Type Company Ltd',
                'Unicredit Ghana Limited',
                'Unilever',
                'University College Of Education - Winneba,Kumasi',
                'University For Development Studies',
                'University Of Energy And Natural Resources (Uenr)',
                'University Of Ghana - Legon',
                'Upper Amenfi Rural Bank',
                'Upper Manya Kro Rural Bank',
                'Utrak Savings And Loans',
                'Valley View',
                'Valley View University Basic School',
                'Vat Service',
                'Volta Hotel',
                'Volta River Authority',
                'Waec - Headquarters',
                'Waec - Main',
                'Wenchi Rural Bank Ltd',
                'West Africa Mills Co. Ltd',
                'Weto Rural Bank',
                'Winners Chapel, Ghana',
                'Womens World Banking',
                'Yaakson Herbal Centre',
                'Yarsako',
              ],
            },
            {
              id: 'employee-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Employee Number',
              uid: 'de5d87a0cd14bafb',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
          ],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas Html',
              uid: 'b25a984636d42a56',
              content:
                '<p><h2>Sign in the area below</h2></p>\n<p><p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p></p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
              markers: [],
              errors: ['*'],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '94903f65f4896769',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'b6a0fbc88aef4a50',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '7c7b941288238d47',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Payment Details',
    uri: 'lifetime-needs-plus/quote',
    class: 'life-time-needs-payment-details',
  },
  'upload-documents': {
    text: [],
    buttons: [
      {
        label: 'Upload ID document',
        id: 'upload-id-document',
        uid: '69a53b6758f4ff80',
        control: false,
      },
      {
        label: 'Upload Passport Document',
        id: 'upload-passport-document',
        uid: '52f9c5a583133af8',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'upload-documents',
      type: 'list',
      readonly: true,
      label: 'Upload Documents',
      uid: '4243c40a669db124',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '2dd71fd55a00cef9',
          content: '<h2 id="upload-documents">Upload Documents</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'ec04f637625f8246',
          content: '<p>Please upload the necessary documentation</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '6c8aa633d46ba070',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#additional">Additional</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#payment">Payment</a></li>\n<li class="done clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          content: [
            {
              content:
                '<p><a href="#upload-id-document" class="">ID Document <span>Re Upload</span></a></p>\n',
              id: 'system-field-outcome',
              label: '',
              readonly: true,
              type: 'html',
              uid: '7721dd56ec3e43de',
            },
            {
              content:
                '<p><a href="#upload-passport-document" class="">Passport Document <span>Re Upload</span></a></p>\n',
              id: 'system-field-outcome',
              label: '',
              readonly: true,
              type: 'html',
              uid: '276a211edc9e33a4',
            },
          ],
          id: 'documents-list',
          label: 'Documents List',
          readonly: true,
          type: 'list',
          uid: '8e9b6f7db40b876c',
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '94903f65f4896769',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'b6a0fbc88aef4a50',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '7c7b941288238d47',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ffp Unlimited Upload Documents',
    uri: 'life-time-needs/upload-documents',
    template: 'life-time-needs-upload-documents-screen',
    class: 'life-time-needs-upload-documents',
  },
  'upload-document-pages': {
    modal: true,
    buttons: [
      {
        control: false,
        id: 'add-page',
        label: 'Add Page',
        uid: '1a5450d98db152d6',
      },
      {
        control: true,
        id: 'abort',
        label: 'Abort',
        uid: 'e11279c7f15a77ea',
      },
      {
        control: true,
        id: 'continue',
        label: 'Continue',
        uid: '0d54090d869303f6',
      },
    ],
    item: {
      content: [
        {
          content:
            '<p>Please upload your document below. If it consists of multiple pages, please upload all of them together.</p>\n',
          id: 'system-field-outcome',
          label: '',
          readonly: true,
          type: 'html',
          uid: '8872705861783d2d',
        },
        {
          content: [],
          id: 'uploads',
          label: 'Uploads',
          readonly: false,
          type: 'table',
          uid: '2d999fbaaefb947c',
        },
        {
          content:
            '<p><a class="button add-page-button" href="#add-page">Add Page</a></p>\n',
          id: 'system-constant',
          label: '',
          readonly: true,
          type: 'html',
          uid: 'a47ce0e3f28e09c5',
        },
      ],
      id: 'upload-section',
      label: 'Upload Section',
      readonly: false,
      type: 'list',
      uid: '74b77d523e9f9b6d',
    },
    class: 'upload-layout',
    context: 'Upload Layout',
    template: '',
    text: [],
    title: 'Public Access \n Welcome to Elac',
    uri: 'upload-document/file/new',
  },
  'acceptance-screen': {
    text: [],
    buttons: [
      {
        label: 'Submit',
        id: 'submit',
        uid: 'ef8243ce592928b2',
        control: false,
      },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'acceptance',
      type: 'list',
      readonly: false,
      label: 'Acceptance',
      uid: '310c42ef81f8d1f5',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '981d430846482fe8',
          content: '<h2 id="summary">Summary</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f07080f78f7cac67',
          content: '<p>Please verify the details below</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output Html',
          uid: '65dbe261db324f63',
          content:
            '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="done clickable"><a href="#payment">Payment</a></li>\n<li class="done clickable"><a href="#uploads">Uploads</a></li>\n<li class="done clickable"><a href="#summary">Summary</a></li>\n</ol>',
        },
        {
          id: 'summary',
          type: 'list',
          readonly: true,
          label: 'Summary',
          uid: 'e638d71c7086f3b6',
          content: [
            {
              id: 'contract-id',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Application Reference Number',
              uid: '0d3a5727942b5c07',
              content: '',
              inputType: 'text',
            },
            {
              id: 'life-assured-identification',
              type: 'list',
              readonly: true,
              label: 'Life Assured Identification',
              uid: '0bcc23bedf598e64',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '7bbd2377a6082cf6',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: '88852b25712cd229',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'idpassport-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID/Passport Number',
                  uid: 'a654664bf843ce16',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '4fbcb5f5033fa4a4',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'title',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Title',
                  uid: '739147d2c5f65eda',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'marital-status',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Marital Status',
                  uid: '3ec2074800e0e60c',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'gender',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Gender',
                  uid: '981762bbc94aec4a',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'id-type',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID Type',
                  uid: 'a5ada630696a64bd',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'life-assured-contact-details',
              type: 'list',
              readonly: true,
              label: 'Life Assured Contact Details',
              uid: 'f006383b12a45b89',
              content: [
                {
                  id: 'cell-phone',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Cell Phone',
                  uid: '463cf8166edfdf3e',
                  content: '',
                  inputType: 'tel',
                },
                {
                  id: 'email',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Email',
                  uid: 'f4c83e8caeaa5a36',
                  content: '',
                  inputType: 'email',
                },
              ],
            },
            {
              id: 'life-assured-postal-address',
              type: 'list',
              readonly: true,
              label: 'Life Assured Postal Address',
              uid: 'abae878974cfc08d',
              content: [
                {
                  id: 'po-box-or-private-bag',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'PO Box Or Private Bag',
                  uid: '49445ab27c5f04bb',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'area-code',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Area Code',
                  uid: '84dffb1b09bbb530',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'suburb',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Suburb',
                  uid: 'c719f01ed7260901',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'town',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Town',
                  uid: '03f7a89d7763e363',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'region',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Region',
                  uid: '94e932258a4747a0',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'trustee-identification',
              type: 'list',
              readonly: true,
              label: 'Trustee Identification',
              uid: '7533c17db58c2bad',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '54bc08110c3136dd',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: '6e7d40576e9016f7',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '890da04c904445a0',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'gender',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Gender',
                  uid: '207dfc6598d452cb',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'trustee-contact-details',
              type: 'list',
              readonly: true,
              label: 'Trustee Contact Details',
              uid: 'c691bb424fec40d3',
              content: [
                {
                  id: 'cell-phone',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Cell Phone',
                  uid: '1204756395d2077f',
                  content: '',
                  inputType: 'tel',
                },
              ],
            },
            {
              id: 'beneficiary-details',
              type: 'table',
              readonly: true,
              label: 'Beneficiary Details',
              uid: '66226a457975532e',
              content: [],
            },
            {
              id: 'payer-person-identification',
              type: 'list',
              readonly: true,
              label: 'Payer Person Identification',
              uid: 'd0cc9018d7b94e75',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '9a1acf70193ff100',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: '3f510801b98ac203',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'idpassport-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID/Passport Number',
                  uid: '2c10a25286fefcd1',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '9f20d39f7c44486d',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'id-type',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID Type',
                  uid: '7bfc02be347d7d05',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'payment-details',
              type: 'list',
              readonly: true,
              label: 'Payment Details',
              uid: '9f4ebc3347190f87',
              content: [],
            },
          ],
        },
        {
          id: 'interactive-canvas-html',
          type: 'component',
          component: 'InteractiveCanvas',
          readonly: false,
          label: 'Interactive Canvas Html',
          uid: '1fcad0e41194c3d1',
          content:
            '<p><h2>Sign in the area below</h2></p>\n<p><p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p></p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
          markers: [],
          errors: ['*'],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '08d553d7fab747a1',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'd216d8335f5602b4',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'eaadfa487ba4adca',
                  content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '28ce4f2f87f3adaa',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '48f061e288e60d8b',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Life Time Needs Acceptance Screen',
    uri: 'lifetime-needs-plus/acceptance',
    template: 'ltn-acceptance-screen',
    class: 'life-time-needs-acceptance-screen',
  },
  completed: {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Continue',
        id: 'continue',
        uid: 'fb11ce7f64c71481',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '95c15702a2e492f8',
      content: ['Application completed successfully.'],
    },
    context: '',
    title: 'Public Access \n Welcome to Elac',
  },
}

export const beneficiaryItem = (b, counter) => [
  {
    id: 'beneficiary-role',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Beneficiary Role',
    uid: `f35595dfe84ccc32-${counter}`,
    content: `Beneficiary-${counter + 1}`,
    inputType: 'text',
  },
  {
    id: 'first-names',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'First Names',
    uid: `7565f9e726f220e7-${counter}`,
    content: b['first-names'] || '',
    inputType: 'text',
  },
  {
    id: 'surname',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Surname',
    uid: `58b5d76aa0eaee8e-${counter}`,
    content: b.surname || '',
    inputType: 'text',
  },
  {
    id: 'date-of-birth',
    type: 'integer',
    elementType: 'input',
    readonly: true,
    label: 'Date Of Birth',
    uid: `7c2b63eca3329b34-${counter}`,
    content: b['date-of-birth'] || '',
    inputType: 'number',
  },
  {
    id: 'gender',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Gender',
    uid: `0031b7feaa76cf4e-${counter}`,
    content: b.gender || '',
    inputType: 'text',
  },
  {
    id: 'role',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Role',
    uid: `c050b22de0adeb79-${counter}`,
    content: b.role || '',
    inputType: 'text',
  },
  {
    id: 'benefit-split',
    type: 'real',
    elementType: 'input',
    readonly: true,
    label: 'Benefit Split',
    uid: `eac9af9f270f00ac-${counter}`,
    content: b['benefit-split'] || '',
    inputType: 'number',
  },
]

export const benefitSplitItem = (b, counter) => ({
  id: `beneficiary-${counter + 1}`,
  type: 'list',
  readonly: false,
  label: `Beneficiary-${counter + 1}`,
  uid: `8dca6eb49ac65bcc-${counter}`,
  content: [
    {
      id: 'system-constant',
      type: 'html',
      readonly: true,
      label: '',
      uid: `7259b360e6ec1490-${counter}`,
      content: `<p>${b['first-names']}</p>\n`,
    },
    {
      id: `beneficiary-split-${counter + 1}`,
      type: 'field',
      elementType: 'input',
      readonly: false,
      label: 'Beneficiary Split',
      uid: `8644e07220d3617d-${counter}`,
      content: b['benefit-split'] || '',
      publishChange: true,
      inputType: 'text',
    },
  ],
})

function range(start, end) {
  return new Array(end - start + 1).fill(undefined).map((_, i) => i + start)
}

export const healthDetailsItem = (count) =>
  range(1, count).map((counter) => ({
    id: `health-concern-${counter}`,
    type: 'list',
    readonly: false,
    label: `Health Concern ${counter}`,
    uid: `39858c9af82649b5-${counter}`,
    content: [
      {
        id: `complaints-${counter}`,
        type: 'field',
        elementType: 'select',
        readonly: false,
        label: 'Complaints',
        uid: `8faa00483cc51798-${counter}`,
        content: '',
        publishChange: true,
        errors: ['*'],
        tooltip: 'Complaints',
        options: [
          '',
          'Alcohol Past Consumption',
          'Arthritis',
          'Cancer',
          'Chest Or Respiratory Disorder',
          'Declined Or Loaded',
          'Diabetes',
          'Good Health',
          'Hazardous Pursuits',
          'Heart Problems',
          'Hereditary Diseases',
          'High Blood Pressure',
          'Hiv Positive',
          'Kidney Problems',
          'Medical Examination',
          'Mental Illness',
          'Nervous System Problems',
          'Other Disorders',
          'Prescribed Medication',
          'Previous Regular Treatment',
          'Previous Surgery',
          'Respiratory Problems',
          'Sexually Transmitted Diseases',
          'Skeletal Problems',
          'Stable Weight',
          'Stomach Problems',
        ],
      },
      {
        id: `complaint-description-${counter}`,
        type: 'field',
        elementType: 'input',
        readonly: false,
        label: 'Complaint Description',
        uid: `26a740e28b18766f-${counter}`,
        content: '',
        publishChange: true,
        errors: ['*'],
        inputType: 'text',
      },
      {
        id: `medical-condition-date-${counter}`,
        type: 'component',
        elementType: 'input',
        readonly: false,
        label: 'Medical Condition Date',
        uid: `f5ec4cc32a4803e5-${counter}`,
        content: '',
        publishChange: true,
        errors: ['*'],
        inputType: 'date',
        component: 'DateSelector',
        maxYear: 2026,
      },
    ],
  }))

export const healthDetailsPrefix = [
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '25e8ba914ed925d9',
    content: '<h2 id="health-description">Health description</h2>\n',
  },
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '4798836a7c99c3c0',
    content:
      '<p>If the answer is &quot;Yes&quot; to questions 2-6 on the previous page please provide details below.</p>\n',
  },
  {
    id: 'output-html',
    type: 'html',
    readonly: true,
    label: 'Output Html',
    uid: '065a26e9f05f3475',
    content:
      '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
  },
]

export const quotationPanel = {
  id: 'quotation-panel',
  type: 'list',
  readonly: true,
  label: 'Quotation Panel',
  uid: 'e2d39fd5ddd26531',
  content: [
    {
      id: 'quotation-information',
      type: 'list',
      readonly: true,
      label: 'Quotation Information',
      uid: '81137de6832cc899',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '315a41b436dd7ca8',
          content: '<p>Lifetime Needs <strong>Plus</strong></p>\n',
        },
        {
          id: 'benefit-rate',
          type: 'amount',
          elementType: 'input',
          readonly: true,
          label: 'Benefit Rate',
          uid: '072265b14f0e0559',
          content: '0.00',
          inputType: 'number',
        },
        {
          id: 'premium',
          type: 'amount',
          elementType: 'input',
          readonly: true,
          label: 'Premium',
          uid: '56cd6d906cbcc71f',
          content: '0.00',
          inputType: 'number',
        },
      ],
    },
  ],
}

export const acceptancePaymentDetails = (form) => {
  if (form['payment-method-selection']['debit-order'] === 'Y') {
    return {
      content: [
        {
          content: form['payment-bank-details']['account-entity-name'] || '',
          elementType: 'input',
          id: 'account-entity-name',
          inputType: 'text',
          label: 'Account Entity Name',
          readonly: true,
          type: 'field',
          uid: 'e47cf0c452614349',
        },
        {
          content: form['payment-bank-details']['account-holder-name'] || '',
          elementType: 'input',
          id: 'account-holder-name',
          inputType: 'text',
          label: 'Account Holder Name',
          readonly: true,
          type: 'field',
          uid: '3d49b733e15abc7c',
        },
        {
          content: form['payment-bank-details']['account-number'] || '',
          elementType: 'input',
          id: 'account-number',
          inputType: 'text',
          label: 'Account Number',
          readonly: true,
          type: 'field',
          uid: 'cf966f446acc41ae',
        },
        {
          content: form['payment-bank-details']['account-type'] || '',
          elementType: 'input',
          id: 'account-type',
          inputType: 'text',
          label: 'Account Type',
          readonly: true,
          type: 'field',
          uid: 'e8cfb99fa1289443',
        },
        {
          content: form['payment-bank-details']['account-branch-name'] || '',
          elementType: 'input',
          id: 'account-branch-name',
          inputType: 'text',
          label: 'Account Branch Name',
          readonly: true,
          type: 'field',
          uid: '30738e87a98b959c',
        },
      ],
      id: 'payment-bank-details',
      label: 'Payment Bank Details',
      readonly: true,
      type: 'list',
      uid: '80eb57ac744be154',
    }
  } else if (form['payment-method-selection']['stop-order'] === 'Y') {
    return {
      id: 'payer-employment-details',
      type: 'list',
      readonly: true,
      label: 'Payer Employment Details',
      uid: '9f4ebc3347190f87',
      content: [
        {
          id: 'employer-organisation',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Employer Organisation',
          uid: '8d379c9e95d45b1c',
          content:
            form['payment-employment-details']['employer-organisation'] || '',
          inputType: 'text',
        },
        {
          id: 'employee-number',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Employee Number',
          uid: '2aeba28f1d28c239',
          content: form['payment-employment-details']['employee-number'] || '',
          inputType: 'text',
        },
      ],
    }
  } else {
    return null
  }
}
